import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild, } from '@angular/core';
import { Observable, Subscription, catchError, debounceTime, distinctUntilChanged, throwError } from 'rxjs';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SECTION, VALIDATION, WIDGET } from '../../models/app-json';
import { ActivatedRoute } from '@angular/router';
import { PAGE } from '../../models/page_config_json';
import { ICON_TYPES, WIDGET_ACTION_NAMES, WIDGET_TYPES, WIDGET_ACTIONS_VALIDATIONS, PAGETYPES, FROMTYPES, WIDGET_CLICK_ACTIONS, VALIDATIONS, MAT_UI_TYPES } from '../../constants/proj.cnst';
import { ToastrService } from 'ngx-toastr';
import { MatChipEditedEvent, MatChipInputEvent } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { WebServiceService } from '../../services/web-service.service';
import { APIConfigMapping, HTTPAPIConfig, VlDataService, VlHttpService, isNullOrUndefined,HighchartsRendererService, ImageCropperComponent, ApiconfigService,CHARTS_LEGEND_ALIGNMENT_MAPPING } from 'shared-library';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatStepper } from '@angular/material/stepper';
import { LEGEND_ALIGN_POSTIONS, LEGEND_VERTICAL_ALIGN_POSTIONS, DATA_SOURCE_TYPES ,MARKER_TYPES} from './constants/const';
import { MOB_AND_WEB_ENTITIES } from './models/models';
import { WebWidgetPropertyFormService } from './web-widget-property-form.service';

@Component({
  selector: 'lib-web-widget-property-forms',
  templateUrl: './web-widget-property-forms.component.html',
  styleUrls: ['./web-widget-property-forms.component.scss'],
  animations: [
    trigger('sidenavFadInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-100px)' }),
        animate('200ms', style({ opacity: 1, transform: 'translateX(0px)' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, transform: 'translateX(0px)' }),
        animate('200ms', style({ opacity: 0, transform: 'translateX(-100px)' }))
      ])
    ]),
  ]
})
export class WebWidgetPropertyFormsComponent implements OnInit, OnDestroy {

  openedContainers: string[] = [];
  page: PAGE = { pageId: "", pageName: "", applicationId: '', pageType: '',forms:[] };
  formsList: any = [];
  displayedContent!: string;
  sideNavSubscription!: Subscription;
  displaySubNav: boolean = false;
  colorCtr!: FormGroup;
  panelOpenState = true;
  selectedActions: any[] = []
  componentOptions: string[] = ['button', "simple list", "navigation"];
  selectedComponents: any[] = [];
  validationValue!: string;
  inputFieldValidationData = ['Required', 'MinLength', 'MaxLength'];
  selectedWidgetTypeConfig!: string;
  validationForm!: FormGroup;
  selectedWidgetMetaData: any = { widgetId: '', key: '', name: '', widgetType: '', style: {}, showDeleteButton: false, customStyleApplied: false };
  selectedColor!: string;
  selectedBgColor!: string;
  openedWidgetForm!: number;
  isClicked: boolean = false;
  dataSourceValues: string[] = [];
  dataSourceApi: any;
  subFormActionsList: any[] = []
  /** form groups for widget properties  */
  textGroup!: FormGroup;
  textFieldGroup!: FormGroup;
  filePickerGroup!: FormGroup;
  imagePickerGroup!: FormGroup;
  selectGroup!: FormGroup;
  buttonGroup!: FormGroup;
  navButtonGroup!: FormGroup;
  FormbuttonGroup!: FormGroup;
  checkBoxGroup!: FormGroup;
  radioButtonGroup!: FormGroup;
  sectionGroup!: FormGroup;
  definedFormGroup!: FormGroup;
  sectionWidgetGroup!: FormGroup;
  dataPickerGroup!: FormGroup;
  buttonActions: any = WIDGET_ACTION_NAMES;
  buttonActionsCpy: any = WIDGET_ACTION_NAMES;
  widgetTypes: any = WIDGET_TYPES;
  iconTpes: any = ICON_TYPES;
  validationNames:any=VALIDATIONS
  widgetActionTypes = WIDGET_CLICK_ACTIONS;
  matUiTypes = MAT_UI_TYPES
  pageTypes = PAGETYPES;
  formTypes = FROMTYPES;
  pagesList: any[] = [];
  widgetMetaEntire: any;
  apiForm!: FormGroup;
  valuesForm!: FormGroup;
  dataSourceTypeForm!: FormGroup;
  subFormAction!: FormGroup;
  apiTriggerAction!: FormGroup;
  conditionNavigationAciton!: FormGroup;
  showMenuGroup!: FormGroup;
  singleInputField!: FormGroup;
  dataSourceTypes = ['API', 'Manual'];
  hasMenu: boolean = false;
  pageIndex!: number;
  imageUploaderSrc = '../assets/images/image-placeholder.webp';
  imageUploaderPhoto!: File;
  lableExisted: boolean = false;
  editedlableExisted: boolean = false;
  isSelectedValidationType: boolean = false;
  requiredField: boolean = false;
  isValidationExist: boolean = false;
  fieldWigets!: any[];
  navigationActionsCount: any[] = [];
  finalnavgationActionList: any[] = [];
  uinavgationActionList: any[] = [];
  conditionalFormList: any[] = [];
  pageNamesandIdList: any[] = [];
  pageNames: any[] = [];
  NavigationConditionals: any[] = [];
  needConditions: boolean = false;
  conditionalActionUpdatedGroup!: FormGroup;
  conditionalActionGroup!: FormGroup;
  listOfconditionalActions!: any[];
  apikeys: any[] = [];
  scannerGroup!: FormGroup;
  navigationGroup!: FormGroup;
  separatorGroup!: FormGroup;
  geoGroup!: FormGroup;
  addressGroup!: FormGroup;
  authApiuserCreds!: FormGroup;
  authApiEmailCreds!: FormGroup;
  previewGroup!: FormGroup;
  dataListGroup!: FormGroup;
  AuthApiGroup!: FormGroup;
  imageUploaderGroup!: FormGroup;
  faceIdGroup!: FormGroup;
  touchIdGroup!: FormGroup;
  itemForm!: FormGroup;
  navTextGroup!: FormGroup;
  tableGroup!:FormGroup;
  selectedPageData: any = {};
  menupaneldetails: any = {};
  checkActualMenu: boolean = false;
  actualpageDetails: any = {};
  /** */
  applicationId: any = '';
  authApikeys: any[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  fieldCtrl = new FormControl('');
  dataField = new FormControl('');
  filteredmsFieldslist: any[] = [];
  msFieldslist: any[] = [];
  msFieldslistnew: any[] = [];
  formWidgetsUpdate: any[] = [];
  msFieldslistUpdate: any[] = []
  conditionalKeyValue: any[] = [];
  dropdownValuesUpdateChip: any[] = [];
  formWidgetsMenuUpdate: any[] = [];

  addOnBlur = true;
  typeApi = false;
  showRadioValueError: string = "";
  dropdownValues: any[] = [];
  selectedField: any;
  showAuthUrlError: boolean = false;

  datalistKeys: string[] = [];
  showEditOption: boolean = false;
  dataListDummyData: any = {
  };

  csWidgetsList: any[] = [];
  actionForm !: FormGroup;
  showRadioErrorMessage: any[] = [];
  s3ImageUrl!:string;
  selectedApiGroup!:FormGroup;
  userApis!:any;
  authApis!:any;

  @ViewChild('payloadInput') payloadInput!: ElementRef<HTMLInputElement>;
  @ViewChild('dropdownAutoDropdown') dropdownAutoDropdown!: MatAutocomplete;
  @ViewChild('dropdownAutoRadio') dropdownAutoRadio!: MatAutocomplete;
  @ViewChild('dropdownAutoCheckBox') dropdownAutoCheckBox!: MatAutocomplete;


  searchTerm: string = '';
  panelStates: boolean[] = [false, false, false, false, false];
  isFilterApplied: boolean = false;
  selectedSectionData: SECTION = { sectionId: "", key: '', name: "", image: "", widgets: [], isEditable: true, showDeleteButton: true, sectionType: '' };
  widgetId: any;
  sectionIndex: any;
  widgetIndex: any;
  label: any;
  formWidgets: any[] = [];
  formWidgetsMenu: any[] = [];
  authApiStatus: any;
  authResposeData: any;
  authApiData: any = {};
  listOfEntitiesOfApplication: any[] = [];
  listOfWidgetsOfEntity: any = [];
  pageIdsOfAssociatedEntity: any[] = [];
  isLengthValidation: boolean = false;
  isMessageValidation: boolean = false;
  showValidationForm: boolean = false;
  isValid: boolean = true;
  isEntityTouched: boolean = false
  previewPageId!: string;
  widgetActionsandValidations: any = WIDGET_ACTIONS_VALIDATIONS;
  isRhsclicked: boolean = false;
  isLhsclicked: boolean = false;
  isLabelEmpty: boolean = false;
  editMode: boolean = false;
  editedDataSourceValue: any;
  selectedValidationIndex: any;
  selectedDataSourceIndex: any
  apiDataSourceApiConfigForm!: FormGroup;
  chartDetailsFormGroup!: FormGroup;
  legendAlignPostions = LEGEND_ALIGN_POSTIONS;
  legendVerticalAlignPositions = LEGEND_VERTICAL_ALIGN_POSTIONS;
  chartDataSourceTypes = DATA_SOURCE_TYPES;
  mapFormGroup! : FormGroup;
  mapDataSourceTypes = DATA_SOURCE_TYPES;
  mapContentData:any[]=[]
  markerTypes = MARKER_TYPES;
  subscrptions: Subscription[] = [];
  listOfEntitiesOfMobAndWebApplication!: MOB_AND_WEB_ENTITIES[];
  legendAlignmentOptions = CHARTS_LEGEND_ALIGNMENT_MAPPING;

  constructor(private sharedService: WebServiceService, private route: ActivatedRoute, private _formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef, private dataService: VlDataService, private toasterService: ToastrService, private http: HttpClient,
    private httpService: VlHttpService, public dialog: MatDialog, private wformService: WebWidgetPropertyFormService,private highChartService:HighchartsRendererService,private clipboard:Clipboard,private apiConfigService:ApiconfigService) {

  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      let pageId = params['pageId'];
      this.applicationId = params['id']
      if (pageId !== undefined) {
        this.sharedService.pages$.subscribe((pages) => {
          this.pageNamesandIdList = [];
          this.pagesList = pages;
          const pageTypesNotToShowInNavigation = [this.pageTypes.previewPage, this.pageTypes.loginPage]
          pages.forEach((page : any) => {
            if (page.pageId !== pageId &&  !pageTypesNotToShowInNavigation.includes(page?.pageType)) {
              this.pageNamesandIdList.push({
                label: page.pageName,
                key: page.pageId,
              });
              this.pageNames.push(page.pageName);
            }

          })
          this.pageIndex = pages.findIndex((page: any) => page.pageId === pageId);
        })

        this.sharedService.selectedPageObj$.subscribe((pageMeta: any) => {
          this.selectedPageData = pageMeta;
          this.selectedComponents = pageMeta.forms;
          if (pageMeta.forms) {
            this.conditionalFormList = [];
            this.formsList = [];
            pageMeta.forms.forEach((form: any) => {
              this.formsList.push({ label: form.formLabel, key: form.formKey });
              this.conditionalFormList.push(form.formLabel);
            })

          }
          this.page = pageMeta;
          pageMeta.forms.forEach((form: any) => {
            if (form?.formConfig?.formType === this.formTypes.menuPanel) {
              this.hasMenu = true;
              this.menupaneldetails = form;
            }
          })
        })


      }
    });
    this.preLoaders()
    this.formbuilder();
    const widgetClickSubscription: any =  this.sharedService.onMobileScreenDropSubjectdata$.subscribe((data: any) => {
      this.unsubscribeAllSubscriptions();
      if (data?.onClick) {
        this.widgetMetaEntire = data;
        this.widgetId = data?.data;
        this.sectionIndex = data?.sectionIndex;
        this.widgetIndex = data?.widgetIndex
        this.displayedContent = data?.widgetMeta?.widgetType;
        this.panelOpenState = true;
        this.selectedWidgetMetaData = data?.widgetMeta;
        if(this.selectedWidgetMetaData.widgetType !=='map')
        this.inputFieldValidationData = [...this.widgetActionsandValidations[this.selectedWidgetMetaData.widgetType]?.validation];
        let selectedValidationMap: any = [];
        let filterValidationData: any = [];
        if (this.selectedWidgetMetaData?.widgetConfig && this.selectedWidgetMetaData?.widgetConfig.validations) {
          this.selectedWidgetMetaData?.widgetConfig?.validations?.length == this.widgetActionsandValidations[this.selectedWidgetMetaData.widgetType].validation?.length ? this.showValidationForm = false : this.showValidationForm = true;
          selectedValidationMap = this.selectedWidgetMetaData?.widgetConfig?.validations.length > 0 ? this.selectedWidgetMetaData?.widgetConfig?.validations.map((ele: any) => ele.validation_type) : [];
          filterValidationData = this.inputFieldValidationData.filter((ele: any) => !selectedValidationMap.includes(ele));
        } else {
          this.showValidationForm = true;
        }
        this.inputFieldValidationData = selectedValidationMap?.length > 0 ? filterValidationData : this.inputFieldValidationData;
        this.selectedWidgetTypeConfig = data?.widgetMeta.type;
        this.selectedColor = data?.widgetMeta?.widgetConfig?.style?.color;
        this.selectedBgColor = data?.widgetMeta?.style?.backgroundColor;
        this.formWidgetlistSetters();
        if(this.selectedWidgetMetaData.widgetType === WIDGET_TYPES.fixedBarChart) {
          const fixedBarChartSubForm = this._formBuilder.group({
            label1: [],
            series1: [],
            label2: [],
            series2: [],
            yAxis1SeriesProperties: this._formBuilder.array([]),
            yAxis2SeriesProperties: this._formBuilder.array([]),
          });
          this.chartDetailsFormGroup.addControl('fixedChartYAxisProperties', fixedBarChartSubForm)
          this.chartDetailsFormGroup.removeControl('yAxisProperties');
        } else {
          let yAxisProperties = this._formBuilder.group({
            label: [],
            series: [],
            individualSeriesProperties: this._formBuilder.array([]),
            dataLabels:[],
            stackLabels:[]
          })
          this.chartDetailsFormGroup.addControl('yAxisProperties', yAxisProperties)
          this.chartDetailsFormGroup.removeControl('fixedBarChartSubForm');
        }
        this.widgetsValuePatcher(this.selectedWidgetMetaData);
        this.csWidgetsListSetter();
        if (this.selectedWidgetMetaData.widgetConfig?.widgetDataSource?.dataSourceType === 'manual') {
          this.showRadioErrorMessage = this.selectedWidgetMetaData?.widgetConfig?.widgetDataSource?.data.map((ele: any) => false);
          this.dataSourceValues = this.selectedWidgetMetaData?.widgetConfig?.widgetDataSource?.data;
        }
        if (this.selectedWidgetMetaData.widgetConfig?.widgetDataSource?.dataSourceType === 'API') {
          this.showRadioErrorMessage = this.selectedWidgetMetaData?.widgetConfig?.widgetDataSource?.data.map((ele: any) => false);
          this.dataSourceApi = this.selectedWidgetMetaData?.widgetConfig?.widgetDataSource?.data;
        }
        if(this.selectedWidgetMetaData?.widgetType ==='map' && this.selectedWidgetMetaData?.widgetConfig?.mapDataSourceData?.length > 0) {
          this.selectedWidgetMetaData?.widgetConfig.mapDataSourceData.forEach((obj:any)=>{
            Object.keys(obj).forEach((key:any)=>{
              if(this.mapContentData.length>0 && !this.mapContentData.includes(key)){
                this.mapContentData.push(key);
              }
            })
          })
      } 
    }
    })
    this.subscrptions.push(widgetClickSubscription);
    this.changeSubscribe();
    this.displayWidgetsSubscribeEvents();
    this.cdRef.detectChanges();
  }

  preLoaders(){
    this.userApis = this.apiConfigService.getUserApis().apis;
    this.authApis = this.apiConfigService.getUserApis().authTypeApis;
    console.log(this.userApis,'userapi');
    console.log(this.authApis,'autj');
    
    
  }

  //subscriberEvents

  displayWidgetsSubscribeEvents() {
    const dataSourceApiConfigForm = this.apiDataSourceApiConfigForm;
    const headerParamsSubscription: any = dataSourceApiConfigForm.get('headerParamsRequired')?.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((isRequired: boolean) => {
        if (isRequired) {
          this.headers.push(this.addHeaders())
        }
      });
    
    this.subscrptions.push(headerParamsSubscription);
    this.subscribeToFormValueChanges(this.chartDetailsFormGroup);

    //value changes
     this.chartDetailsFormGroup.get('dataSourceType')?.valueChanges.subscribe((value) => {
      if(value === 'api'){
        this.selectedApiGroup.get('selectedApi')?.setValidators(Validators.required);
        this.chartDetailsFormGroup.get('entity')?.setValidators(null);
      }else{
        this.chartDetailsFormGroup.get('entity')?.setValidators(Validators.required);
        this.selectedApiGroup.get('selectedApi')?.setValidators(null);

      }
    })
  }

  subscribeToFormValueChanges(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.get(controlName);

      if (control instanceof FormGroup) {
        this.subscribeToFormValueChanges(control);
      } else {
        const valueChangeSubscription: any = control?.valueChanges
        .pipe(debounceTime(300), distinctUntilChanged())
        .subscribe(value => {
          switch (controlName) {
            case 'series': this.formatTheSeriesPropertiesFormArray(value);
              break;
            case 'series1' : this.formatFixeBarYAxisProperties(value, this.yAxis1SeriesProperties)
              break;
            case 'series2' : this.formatFixeBarYAxisProperties(value, this.yAxis2SeriesProperties)
              break;

            default: break;
          }
          this.selectedWidgetMetaData.widgetConfig.chartConfig = this.chartDetailsFormGroup.value;
          if(this.selectedWidgetMetaData.widgetType!=='map')
          this.highChartService.SetUpdatedDisplayWidgetDataConfig(true);        
        });
        this.subscrptions.push(valueChangeSubscription);
      }
    });
  }

  formatTheSeriesPropertiesFormArray(value: string[]) {
    for (let i = this.individualSeriesProperties.length - 1; i >= 0; i--) {
      const control = this.individualSeriesProperties.at(i) as FormControl;
      if (!value.includes(control.value?.key)) {
        this.individualSeriesProperties.removeAt(i);
      }
    }
    value.forEach(item => {
      const containsItem = this.individualSeriesProperties.value.some((val: { label: string, key: string }) => val.key === item);
      if (!containsItem) {
        this.individualSeriesProperties.push(
          this._formBuilder.group({
            label: [],
            key: item,
            color: ['blue']
          })
        );
      }
    });
  }

  formatFixeBarYAxisProperties(value: string[], seriesProperties : any) {
    for (let i = seriesProperties.length - 1; i >= 0; i--) { 
      const control = seriesProperties.at(i) as FormControl;
      if (!value.includes(control.value?.key)) {
        seriesProperties.removeAt(i);
      }
    }
    value?.forEach(item => {
      const containsItem = seriesProperties.value.some((val: { label: string, key: string }) => val.key === item);
      if (!containsItem) {
        seriesProperties.push(
          this._formBuilder.group({
            label: [],
            key: item,
            color: ['#0000FF']
          })
        );
      }
    });
  }


  addApiHeaderParams() {
    this.headers.push(this.addHeaders())
  }

  addHeaders(): FormGroup {
    return this._formBuilder.group({
      key: [],
      value: []
    });
  }

  deleteHeader(index: number) {
    this.headers.removeAt(index);
  }

  addApiPostParams() {
    this.apiPostData.push(this.addHeaders());
  }

  deletePostParam(index: number) {
    this.apiPostData.removeAt(index);
  }

  saveApiorEnityConfig() {
    const dataSourceApiConfig = this.apiDataSourceApiConfigForm.value;
    const widgetType = this.selectedWidgetMetaData.widgetType
    const widgetConfig =  this.selectedWidgetMetaData.widgetConfig;
    widgetConfig[widgetType === 'map' ? 'mapDataSourceApiConfig' : 'chartDataSourceApiConfig'] = dataSourceApiConfig;
    this.closeTemplate();
  }
  

  async getActualPage() {
    this.actualpageDetails = await this.sharedService.getPageById(this.selectedPageData.pageId)
      .toPromise();
    this.actualpageDetails.forms.forEach((form: any) => {
      if (form.formConfig.formType == this.formTypes.menuPanel) {
        this.checkActualMenu = true;
      }
    })
  }

  //#region  parameters field

  onConditionSectionSelect(event: any) {
    console.log(event);
    this.selectedComponents.forEach((form) => {
      if (form.formKey === event.value) {
        this.csWidgetsList = form.widgets
      }
    })
  }

  csWidgetsListSetter() {
    if (this.selectedComponents[this.sectionIndex].widgets) {
      this.csWidgetsList = this.selectedComponents[this.sectionIndex].widgets.filter((widget: any) => widget.widgetType !== this.widgetTypes.button);
    }
  }

  formWidgetlistSetters() {
    if (this.selectedComponents) {
      this.formWidgetsMenu = [];
      this.formWidgets = [];
      this.filteredmsFieldslist = [];
      this.selectedComponents[this.sectionIndex]?.widgets.forEach((widget: any) => {
        if (widget.widgetType !== this.widgetTypes.button) {
          this.formWidgets.push(widget);
          if (widget.widgetType == this.widgetTypes.dropdown || widget.widgetType == this.widgetTypes.radio || widget.widgetType == this.widgetTypes.singleselectcheckbox)
            this.formWidgetsMenu.push(widget);
        }

        this.NavigationConditionals = [];
      })
    }
  }
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      if (!this.msFieldslist.includes(value)) {
        this.csWidgetsList = this.csWidgetsList.filter((item: any) => item.widgetLabel != value)
        this.msFieldslist.push(value);
      }
    }

    // Clear the input value
    event.chipInput!.clear();

    this.fieldCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.msFieldslist.indexOf(fruit);

    if (index >= 0) {
      this.msFieldslist.splice(index, 1);
      this.formWidgets.push(fruit);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.msFieldslist) {
      let value = event.option.value;
      if (!this.msFieldslist.includes(value)) {
        this.formWidgets = this.formWidgets.filter((item: any) => item !== value);
        this.msFieldslist.push(value);
      }
      this.payloadInput.nativeElement.value = '';
      this.fieldCtrl.setValue(null);
    }
    else {
      this.msFieldslist = []
      this.msFieldslist.push(event.option.viewValue);
      this.formWidgets = this.formWidgets.filter((item: any) => item !== event.option.viewValue)
      this.payloadInput.nativeElement.value = '';
      this.fieldCtrl.setValue(null);
    }
  }

  removeItemValuenew(widgetData: any, navIndex: any, index: any): void {
    if (index >= 0) {
      this.NavigationConditionals[navIndex].values.splice(index, 1);
      if (widgetData.widgetDataSource && widgetData.widgetDataSource.datasource) {
        this.dropdownValues = widgetData.widgetDataSource.datasource.filter(
          (item: any) => !this.NavigationConditionals[index]?.values.includes(item.label))
      }
    }
  }

  onInputClick(widgetData: any, index: any) {
    if (widgetData.widgetType == this.widgetTypes.dropdown && widgetData.widgetDataSource.datasourceType == 'manual') {
      this.dropdownValues = [];

      this.dropdownValues = widgetData.widgetDataSource.datasource.filter(
        (item: any) => !this.NavigationConditionals[index]?.values.includes(item.label))
    }

    else if (widgetData.widgetType == this.widgetTypes.radio) {
      this.dropdownValues = [];

      this.dropdownValues = widgetData.widgetDataSource.datasource.filter(
        (item: any) => !this.NavigationConditionals[index]?.values.includes(item.label))
    }
    else if (widgetData.widgetType == this.widgetTypes.singleselectcheckbox) {
      this.dropdownValues = ['checked', 'unchecked'];
    }

    else {
      this.dropdownValues = [];
    }
  }

  onInputClickParameterUpdate() {
  }

  addnew(event: MatChipInputEvent): void {
  }

  selectednew(event: MatAutocompleteSelectedEvent, type: any): void {
    let value = event.option.value;

    if (type == this.widgetTypes.dropdown && this.NavigationConditionals) {
      const index = this.NavigationConditionals.findIndex((item: any) => item.key.widgetType === this.widgetTypes.dropdown);
      if (index !== -1) {
        this.NavigationConditionals[index].values.push(value.label);
        this.dropdownValues = this.dropdownValues.filter((item: any) => item !== value)
      }
    }

    if (type == this.widgetTypes.radio && this.NavigationConditionals) {
      const index = this.NavigationConditionals.findIndex((item: any) => item.key.widgetType === this.widgetTypes.radio);
      if (index !== -1) {
        this.NavigationConditionals[index].values.push(value.label);
        this.dropdownValues = this.dropdownValues.filter((item: any) => item !== value)
      }
    }
    if (type == this.widgetTypes.singleselectcheckbox && this.NavigationConditionals) {
      const index = this.NavigationConditionals.findIndex((item: any) => item.key.widgetType === this.widgetTypes.singleselectcheckbox);
      if (index !== -1) {
        this.NavigationConditionals[index].values.push(value.label);
        this.dropdownValues = this.dropdownValues.filter((item: any) => item !== value)
      }
    }
  }

  //#endregion

  //#region dataList widget 

  get lhsItems() {
    return this.dataListGroup.get('lhsItems') as FormArray;
  }

  get rhsItems() {
    return this.dataListGroup.get('rhsItems') as FormArray;
  }

  //#endregion

  showContent(component: string) {
    this.displayedContent = component;
    this.openedContainers.push(component);
  }


  formbuilder() {
    this.textGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [, [Validators.required]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.selectedApiGroup = this._formBuilder.group({
      selectedApi:[]
    })

    this.navTextGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [],
    });

    this.dataPickerGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      matUiType: [],
      label: [, [Validators.required]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.textFieldGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      matUiType: [],
      type: [],
      label: [, [Validators.required]],
      placeholder: [],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.sectionWidgetGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      type: [],
      label: [, [Validators.required]],
      placeholder: []
    });

    this.selectGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      matUiType: [],
      label: [, [Validators.required]],
      type: [],
      placeholder: [],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.filePickerGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      matUiType: [],
      label: [, [Validators.required]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.imagePickerGroup = this._formBuilder.group({
      key: [],
      textColor: ['#000000'],
      matUiType: [],
      label: [, [Validators.required]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.buttonGroup = this._formBuilder.group({
      key: [],
      matUiType: [],
      textColor: [],
      label: [, [Validators.required]],
      bgColor: [],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.navButtonGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      image: [],

    });
    this.showMenuGroup = this._formBuilder.group({
      showMenu: false,
    })

    this.FormbuttonGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [],
      bgColor: [],
      width: [],
    });

    this.checkBoxGroup = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [, [Validators.required]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.radioButtonGroup = this._formBuilder.group({
      key: [],
      title: [, [Validators.required]],
      textColor: [],
      value1label: [],
      value2label: [],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.imageUploaderGroup = this._formBuilder.group({
      key: [],
    })

    this.faceIdGroup = this._formBuilder.group({
      key: [],
    })

    this.touchIdGroup = this._formBuilder.group({
      key: [],
    })

    this.sectionGroup = this._formBuilder.group({
      key: [],
      label: [, [Validators.required]],
      bgColor: [],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    })

    this.definedFormGroup = this._formBuilder.group({
      bgColor: []
    })

    this.validationForm = this._formBuilder.group({
      selectedValidationType: [''],
      requiredMessage: [''],
      validationValue: ['']
    })

    this.subFormAction = this._formBuilder.group({
      action: ['', Validators.required],
      value: ['', Validators.required]
    })

    this.apiTriggerAction = this._formBuilder.group({
      actionType: ['', Validators.required],
      apiUrl: ['', Validators.required]
    })

    this.apiForm = this._formBuilder.group({
      needAuth: false,
      apiUrl: ['', Validators.required],
      method: ['', Validators.required],
      payload: [],
      responseParameter: [],
      authApiUrl: [''],
      auth: [''],
      apiKey: [''],
    });

    this.AuthApiGroup = this._formBuilder.group({
      authApiUrl: ['', Validators.required],
      auth: ['', Validators.required],
      apiKey: [''],
    })
    this.previewGroup = this._formBuilder.group({
      preview: []
    })

    this.authApiuserCreds = this._formBuilder.group({
      authUsername: [, Validators.required],
      authPassword: [, Validators.required]
    });

    this.authApiEmailCreds = this._formBuilder.group({
      authEmail: [, Validators.required],
      authPassword: [, Validators.required]
    })

    this.valuesForm = this._formBuilder.group({
      label: ['', Validators.required]
    });

    this.dataSourceTypeForm = this._formBuilder.group({
      dataSourceType: ['', Validators.required],
    });

    this.singleInputField = this._formBuilder.group({
      value: ['', Validators.required],
    });

    this.conditionNavigationAciton = this._formBuilder.group({
      action: ['', Validators.required],
      parameters: ['',]
    })

    this.navigationGroup = this._formBuilder.group({
      pageName: ['', Validators.required]
    })

    this.conditionalActionGroup = this._formBuilder.group({
      pageName: ['', Validators.required]
    })

    this.conditionalActionUpdatedGroup = this._formBuilder.group({
      pageName: ['', Validators.required]
    })

    this.scannerGroup = this._formBuilder.group({
      key: [],
      label: [, [Validators.required]],
      matUiType: [],
      textColor: [],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.separatorGroup = this._formBuilder.group({
      key: [],
      thickness: [5, [Validators.required, Validators.min(1)]],
      textColor: [],
    });
    this.geoGroup! = this._formBuilder.group({
      key: [],
      textColor: [],
      label: [, [Validators.required]],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    })
    this.addressGroup = this._formBuilder.group({
      key: [],
      matUiType: [],
      textColor: [],
      label: [, [Validators.required]],
      placeholder: [],
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    });

    this.dataListGroup = this._formBuilder.group({
      key: [],
      type: '',
      entity: ['', Validators.required],
      lhsItems: this._formBuilder.array([]),
      rhsItems: this._formBuilder.array([]),
      textColor: '',
      bold: false,
      italic: false,
      underline: false,
      fontSize: 0
    })

    this.actionForm = this._formBuilder.group({
      selectedAction: ['']
    })

    this.chartDetailsFormGroup = this._formBuilder.group({
      key: [],
      title: [],
      description: [],
      dataSourceType: [],
      entity: [],
      xAxisProperties: this._formBuilder.group({
        label: [],
        categories: []
      }),
      yAxisProperties: this._formBuilder.group({
        label: [],
        series: [],
        individualSeriesProperties: this._formBuilder.array([]),
        dataLabels:[],
        stackLabels:[]
      }),
      legendPropertyies: this._formBuilder.group({
        displayLegend: [],
        legendAlignment: [1,],
      })
    })

    this.apiDataSourceApiConfigForm = this._formBuilder.group({
      apiUrl: [],
      httpMethod: [],
      headerParamsRequired: [false],
      headers: this._formBuilder.array([]),
      apiPostData: this._formBuilder.array([])
    })

    this.mapFormGroup = this._formBuilder.group({ 
      key: [],
      title: [],
      dataSourceType: [],
      entity: [],
      zoom: [, [Validators.required, Validators.min(0)]],
      markerProps: this._formBuilder.group({
        markerType: [, [Validators.required]],
        size : 0,
        color : '',
        lat : [,[Validators.required]],
        lon : [,[Validators.required]],
        radius : 0
      }),
      contentProps : this._formBuilder.group({
        contentKeys : []
      })
    });
    
    this.tableGroup = this._formBuilder.group({
      key: [],
      title: [],
      description: [],
      dataSourceType: [],
      entity: [],
      dataProperties:this._formBuilder.group({
        tableHeaders:[],
        rowsPerPage:[],
        filterOptions:[]
      })

    })

    this.initializeMenuPanelForm();
  }

  get individualSeriesProperties() {
    return (this.chartDetailsFormGroup.get('yAxisProperties') as FormGroup)?.get('individualSeriesProperties') as FormArray;
  }

  get yAxis1SeriesProperties(){
    return (this.chartDetailsFormGroup.get('fixedChartYAxisProperties') as FormGroup)?.get('yAxis1SeriesProperties') as FormArray;
  }

  get yAxis2SeriesProperties(){
    return (this.chartDetailsFormGroup.get('fixedChartYAxisProperties') as FormGroup)?.get('yAxis2SeriesProperties') as FormArray;
  }

  get headers() {
    return this.apiDataSourceApiConfigForm.get('headers') as FormArray;
  }

  get apiPostData() {
    return this.apiDataSourceApiConfigForm.get('apiPostData') as FormArray;
  }

  async widgetsValuePatcher(widget: any) {
    let textColor = (widget.widgetConfig.style )?.['color'] ?? '';
    let bgColor = (widget.widgetConfig.style as any)?.['backgroundColor'] || '';
    let placeholder;
    let label;
    if (widget.element) {
      label = widget.element.label;
      placeholder = widget.element.placeholderText;
    }
    switch (widget.widgetType) {
      case this.widgetTypes.plainText:
        this.textGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
        });
        this.patchStyleProperties(this.textGroup, widget);
        break;

      case this.widgetTypes.navText:
        this.navTextGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
        });
        break;

      case this.widgetTypes.separator:
        let borderWidth = (widget.widgetConfig.style as any)?.["size"] || "5px";
        this.separatorGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          thickness: borderWidth.slice(0, -2),
        });
        break;

      case this.widgetTypes.date:
        this.dataPickerGroup.patchValue({
          key: widget.widgetKey,
          matUiType: widget.widgetConfig.matUiType,
          textColor: textColor,
          label: widget.widgetLabel,
        });
        this.patchStyleProperties(this.dataPickerGroup, widget);
        break;

      case this.widgetTypes.geotag:
        this.geoGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
        });
        this.patchStyleProperties(this.geoGroup, widget);
        break;

      case this.widgetTypes.textbox:
        this.textFieldGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          matUiType: widget.widgetConfig.matUiType,
          type: widget.widgetConfig.type,
          label: widget.widgetLabel,
          placeholder: widget.widgetConfig.placeholderText,
        });
        this.patchStyleProperties(this.textFieldGroup, widget);
        break;

      case this.widgetTypes.address:
        this.addressGroup.patchValue({
          key: widget.widgetKey,
          matUiType: widget.widgetConfig.matUiType,
          textColor: textColor,
          type: widget.widgetConfig.type,
          label: widget.widgetLabel,
          placeholder: widget.widgetConfig.placeholderText,
        });
        this.patchStyleProperties(this.addressGroup, widget);
        break;

      case this.widgetTypes.dropdown:
        this.selectGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          matUiType: widget.widgetConfig.matUiType,
          label: widget.widgetLabel,
          type: widget.widgetConfig?.type,
          placeholder: widget.widgetConfig.placeholderText
            ? widget.widgetConfig.placeholderText
            : "select values",
        });
        this.patchStyleProperties(this.selectGroup, widget);
        break;

      case this.widgetTypes.imageUploader:
        this.s3ImageUrl = this.getImageFile(widget.widgetConfig.image);
        this.imageUploaderGroup.patchValue({
          key: widget.widgetKey,
        });
        break;

      case this.widgetTypes.faceId:
        this.faceIdGroup.patchValue({
          key: widget.widgetKey,
        });
        break;

      case this.widgetTypes.fingerPrint:
        this.touchIdGroup.patchValue({
          key: widget.widgetKey,
        });
        break;

      case this.widgetTypes.searchableDropdown:
        this.selectGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          type: widget.type,
          placeholder: widget.widgetConfig.placeholderText
            ? widget.widgetConfig.placeholderText
            : "select values",
        });
        this.patchStyleProperties(this.selectGroup, widget);
        break;

      case this.widgetTypes.filePicker:
        this.filePickerGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          matUiType: widget.widgetConfig.matUiType,
        });
        this.patchStyleProperties(this.filePickerGroup, widget);
        break;

      case this.widgetTypes.image:
        this.imagePickerGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
          matUiType: widget.widgetConfig.matUiType,
        });
        this.patchStyleProperties(this.imagePickerGroup, widget);
        break;

      case this.widgetTypes.button:
        this.buttonGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          matUiType: widget.widgetConfig.matUiType,
          label: widget.widgetLabel,
          bgColor: bgColor,
        });
        this.patchStyleProperties(this.buttonGroup, widget);
        break;

      case this.widgetTypes.navButton:
        this.getActualPage();
        this.navButtonGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          image: widget.widgetConfig?.image,
        });
        let status = this.sharedService.getShowMenuStatus();
        this.showMenuGroup.patchValue({
          showMenu: status,
        });
        break;

      case this.widgetTypes.singleselectcheckbox:
        this.checkBoxGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          label: widget.widgetLabel,
        });
        this.patchStyleProperties(this.checkBoxGroup, widget);
        break;

      case this.widgetTypes.radio:
        this.radioButtonGroup.patchValue({
          key: widget.widgetKey,
          textColor: textColor,
          title: widget.widgetLabel,
        });
        this.patchStyleProperties(this.radioButtonGroup, widget);
        break;

      case this.widgetTypes.scanner:
        this.scannerGroup.patchValue({
          key: widget.widgetKey,
          matUiType: widget.widgetConfig.matUiType,
          label: widget.widgetLabel,
          textColor: textColor,
        });
        this.patchStyleProperties(this.scannerGroup, widget);
        break;

      case this.widgetTypes.datalist:
        const payload = {
          application_id: this.applicationId,
          entity_id: null,
          project_id: null,
          parent_entity_id: null,
        };
        this.listOfEntitiesOfApplication = await this.getEntitiesOrAttributes(
          payload
        ).toPromise();
        const dataListWidgetConfig = widget.widgetConfig?.dataListWidgetConfig;
        if (dataListWidgetConfig?.entityId) {
          payload.entity_id = dataListWidgetConfig.entityId;
          const listOfPageWidgetsOfEntity = await this.getEntitiesOrAttributes(
            payload
          ).toPromise();
          this.pageIdsOfAssociatedEntity =
            listOfPageWidgetsOfEntity?.page_ids ?? [];
          this.listOfWidgetsOfEntity = this.retriveWidgetsListFromEntiy(
            listOfPageWidgetsOfEntity?.page_widget_details
          );
          this.lhsItems.clear();
          dataListWidgetConfig.lhsItems?.forEach((item: any) => {
            this.lhsItems.push(this.patchField(item.widgetId));
          });
          this.rhsItems.clear();
          dataListWidgetConfig.rhsItems?.forEach((item: any) => {
            this.rhsItems.push(this.patchField(item.widgetId));
          });

          const formatedList = dataListWidgetConfig.listOfWidgetsOfEntity
            ?.map((item1: any) => {
              const matchingItem2 = this.listOfWidgetsOfEntity?.find(
                (item2: any) => item1.widgetId === item2.widgetId
              );
              return matchingItem2
                ? {
                    widgetId: item1.widgetId,
                    show: item1.show,
                    ...matchingItem2,
                  }
                : null;
            })
            .filter(Boolean);
          this.listOfWidgetsOfEntity?.forEach((item2: any) => {
            if (
              !formatedList?.some(
                (item: any) => item && item.widgetId === item2.widgetId
              )
            ) {
              formatedList?.push({
                widgetId: item2.widgetId,
                show: false,
                widgetLabel: item2.widgetLabel,
              });
            }
          });

          this.listOfWidgetsOfEntity =
            dataListWidgetConfig.listOfWidgetsOfEntity
              ? formatedList
              : this.formatListOfwidgetsOfEntity(this.listOfWidgetsOfEntity);
        }

        this.dataListGroup.patchValue({
          key: widget.widgetKey,
          type: "Card",
          entity: dataListWidgetConfig?.entityId,
          bold: false,
          italic: false,
          underline: false,
          fontSize: 0,
        });

        break;

      case this.widgetTypes.barChart:
      case this.widgetTypes.lineChart:
      case this.widgetTypes.pieChart:
      case this.widgetTypes.stackBarChart:
      case this.widgetTypes.donutChart:
      case this.widgetTypes.fixedBarChart:
        this.yAxis1SeriesProperties?.clear();
        this.yAxis2SeriesProperties?.clear()
        this.listOfEntitiesOfMobAndWebApplication = await this.wformService.getMobAndWebEntities().toPromise()
        const chartConfig = widget.widgetConfig.chartConfig;
        const chartDataSourceConfig = widget.widgetDataSource;
          const chartData = widget.widgetConfig.chartDataSourceData;
        this.chartDetailsFormGroup.patchValue(chartConfig, {
          emitEvent: false,
          onlySelf: true,
        });
        this.individualSeriesProperties.clear();
        chartConfig?.yAxisProperties?.individualSeriesProperties?.forEach(
          (prop: any) => {
            this.individualSeriesProperties.push(
              this._formBuilder.group({
                label: prop.label,
                key: prop.key,
                color: prop.color,
              })
            );
          }
        );
        chartConfig?.fixedChartYAxisProperties?.yAxis1SeriesProperties?.forEach((prop: any) => {
          this.yAxis1SeriesProperties.push(
            this._formBuilder.group({
              label: prop.label,
              key: prop.key,
              color: prop.color
            })
            )
          })
        chartConfig?.fixedChartYAxisProperties?.yAxis2SeriesProperties?.forEach((prop: any) => {
            this.yAxis2SeriesProperties.push(
              this._formBuilder.group({
                label: prop.label,
                key: prop.key,
                color: prop.color
              })
              )
          })
          if (chartDataSourceConfig) {
            this.selectedApiGroup.patchValue({
              selectedApi: chartDataSourceConfig.datasource
            }, {emitEvent: false, onlySelf: true});
           chartData ? this.handleResponse(chartData) : this.getApiOrEntityDefinitionBasedOnForm('api',chartDataSourceConfig.dataSource );
          }
          else if (chartConfig?.entity) {
            chartData ? this.handleResponse(chartData) : this.getApiOrEntityDefinitionBasedOnForm('entity', chartDataSourceConfig.dataSource);
          }else{
            this.chartDetailsFormGroup.reset();  
          }
        break;
      case this.widgetTypes.map:
        this.listOfEntitiesOfMobAndWebApplication = await this.wformService
          .getMobAndWebEntities()
          .toPromise();
        const mapConfig = widget.widgetConfig.mapConfig;
        const mapDataSourceApiConfig =
          widget.widgetConfig.mapDataSourceApiConfig;
        this.mapFormGroup.patchValue(mapConfig, {
          emitEvent: false,
          onlySelf: true,
        });
        if (mapDataSourceApiConfig) {
          this.apiDataSourceApiConfigForm.patchValue(mapDataSourceApiConfig, {
            emitEvent: false,
            onlySelf: true,
          });
          this.getApiOrEntityDefinitionBasedOnForm(
            "api",
            "apiDataSourceApiConfigForm"
          );
        } else if (mapConfig?.entity) {
          this.getApiOrEntityDefinitionBasedOnForm("entity", "mapFormGroup");
        }
        break;

      case this.widgetTypes.table:
        this.tableGroup.reset();
        if (widget.widgetConfig.tableConfig) {
          
          let tableConfig = widget.widgetConfig.tableConfig;
          this.wformService.setSelectedTableConfig(tableConfig);
          const chartDataSourceConfig = widget.widgetDataSource;
          const tableData = widget.widgetConfig.tableData;
          this.tableGroup.patchValue({
            key: widget.widgetId,
            title: tableConfig.title,
            dataSourceType: tableConfig.dataSourceType,
            entity: tableConfig.entity,
          });
          this.tableGroup.get('dataProperties')?.patchValue({
              rowsPerPage: tableConfig.dataProperties.rowsPerPage,
              tableHeaders: tableConfig.dataProperties.tableHeaders,
              filterOptions: tableConfig.dataProperties.filterOptions})

          if (chartDataSourceConfig) {
            this.selectedApiGroup.patchValue({
              selectedApi: chartDataSourceConfig.datasource
            }, {emitEvent: false, onlySelf: true});
           tableData ? this.handleResponse(tableData) : this.getApiOrEntityDefinitionBasedOnForm('api',chartDataSourceConfig.dataSource );
          }
          else if (chartConfig?.entity) {
            tableData ? this.handleResponse(tableData) : this.getApiOrEntityDefinitionBasedOnForm('entity', chartDataSourceConfig.dataSource);
          }else{
            this.chartDetailsFormGroup.reset();  
          }
        }else{
          this.tableGroup.patchValue({
            key: widget.widgetId,
            title: '',
          });
        }
        break;

      default:
        console.warn("Unsupported widget type:", widget.widgetType);
        break;
    }
  
    if (widget && widget.widgetConfig?.actions && widget.widgetType!=='map') {
      this.selectedActions = [];
      this.actionForm.reset();
      this.navigationGroup.reset();
      this.buttonActions = [...this.widgetActionsandValidations[this.selectedWidgetMetaData.widgetType].action];

      if (widget.widgetConfig?.actions.length > 0) {
        let widgetActions = widget.widgetConfig?.actions;
        widgetActions.forEach((action: any) => {
          if (action.action_type === this.widgetActionTypes.navigation) {
            let pageID = action["conditional_clause"][0]?.['action'];
            let pagename;
            this.pageNamesandIdList.forEach((page) => {
              if (page.key == pageID) {
                pagename = page.label;
              }
            })
            this.navigationGroup.patchValue({
              pageName: pagename
            })
            this.addAction(this.widgetActionTypes.navigation);
          }
          if (action.action_type === 'subform') {
            this.listOfconditionalActions = [];
            if (this.listOfconditionalActions) {
              this.listOfconditionalActions = action["conditional_clause"]
            }
            else {
              this.listOfconditionalActions = [];
            }
            this.addAction(this.widgetActionTypes.conditionalNavigation);
          }
          if (action.action_type === 'Api-trigger') {
            this.apiForm.reset();
            this.apiTriggerAction.patchValue({

              actionType: widget.widgetConfig?.actions?.["request_type"],
              apiUrl: widget.widgetConfig?.actions?.["apiurl"],
            })
            this.dataSourceTypeForm.patchValue({
              dataSourceType: "API",
            })
            this.apiForm.patchValue({
              apiUrl: widget.widgetDataSource?.datasource,
              method: widget.widgetDataSource?.method,
              payload: widget.widgetDataSource?.['request-parameter'],
              responseParameter: widget.widgetDataSource?.['response-parameter']?.label ? widget.widgetDataSource?.['response-parameter'].label : '',
              authApiUrl: widget.widgetDataSource.Authorization?.['auth-api-url'],
              auth: widget.widgetDataSource.Authorization?.['auth'],
              apiKey: widget.widgetDataSource.Authorization?.['api-key']
            });
            this.previewGroup.patchValue({
              preview: widget.widgetDataSource?.preview,
            })
            let values: any[] = widget.widgetDataSource?.['request-parameter'];
            if (values?.length > 0) {
              this.msFieldslist = [];
              values.forEach((key: any) => {
                this.formWidgets.forEach((field) => {
                  if (field.widgetKey == key) {
                    this.msFieldslist.push(field);

                  }
                })

                this.msFieldslist.forEach((value) => {
                  this.formWidgets = this.formWidgets.filter(
                    (item: any) => item !== value
                  );
                });
              })
            } else {
              this.msFieldslist = [];
            }
            this.addAction(this.widgetActionTypes.submit);
          }
        })
      }
      else {
        this.selectedActions = [];
      }
    }
    if (widget?.widgetDataSource && widget.widgetDataSource?.datasourceType?.toLowerCase() === 'manual' && widget.widgetType === this.widgetTypes.dropdown) {
      this.dataSourceTypeForm.patchValue({
        dataSourceType: 'Manual',
      })
      let dataValues = widget.widgetDataSource.datasource ?? [];
      if (dataValues.length > 0) {
        this.dataSourceValues = [];
        dataValues.forEach((obj: any) => {
          this.dataSourceValues.push(obj.label);
        })

      }
      else {
        this.dataSourceValues = [];
        this.buttonActions = WIDGET_ACTION_NAMES;
      }
    }
    else if (widget?.widgetDataSource && widget.widgetDataSource?.datasourceType?.toLowerCase() === 'api'  && widget.widgetType === this.widgetTypes.dropdown) {
      this.typeApi = true;
      this.dataSourceTypeForm.patchValue({
        dataSourceType: "API",
      })
      this.apiForm.patchValue({
        apiUrl: widget.widgetDataSource?.datasource,
        method: widget.widgetDataSource?.method,
        payload: widget.widgetDataSource?.['request-parameter'],
        responseParameter: widget.widgetDataSource?.['response-parameter']?.label ? widget.widgetDataSource?.['response-parameter'].label : '',
        authApiUrl: widget.widgetDataSource.Authorization?.['auth-api-url'],
        auth: widget.widgetDataSource.Authorization?.['auth'],
        apiKey: widget.widgetDataSource.Authorization?.['api-key'],
      })
      let values = widget.widgetDataSource?.['request-parameter'];
      if (values.length > 0) {
        this.msFieldslist = [];
        values.forEach((key: any) => {
          this.formWidgets.forEach((field) => {
            if (field.widgetKey == key) {
              this.msFieldslist.push(field);

            }
          })

          this.msFieldslist.forEach((value) => {
            this.formWidgets = this.formWidgets.filter(
              (item: any) => item !== value
            );
          });
        })
      } else {
        this.msFieldslist = [];
      }

    } else {
      this.typeApi = false;
      this.apiForm.reset();
      this.dataSourceTypeForm.reset();
      this.msFieldslist = [];
    }
  }





  // Add Component

  onDragStart(event: DragEvent, item: SECTION | WIDGET): void {
    event.dataTransfer!.setData('text/plain', JSON.stringify(item));
    this.sharedService.setDisplayRestrictedArea(true);
  }

  onDragEnd(event: DragEvent): void {

    if (!event.dataTransfer!.dropEffect) {
    }
    this.sharedService.setDisplayRestrictedArea(false);
  }

  onSelectChange() {
    this.isSelectedValidationType = false;
    this.isValidationExist = false;
    this.isLengthValidation = false;
    if (this.validationForm.get('selectedValidationType')?.value === 'Maximun Length' || this.validationForm.get('selectedValidationType')?.value === 'Minimum Length') {
      this.isValid = true;
    }
    if (this.validationForm.get('requiredMessage')?.value || this.validationForm.get('validationValue')?.value) {
      this.validationForm.get('requiredMessage')?.reset();
      this.validationForm.get('validationValue')?.reset();
      this.isValid = true;
    }
    if (this.validationForm.get('selectedValidationType')?.value === 'Required') {
      this.isValid = false;
    }
  }

  onLengthAdd(event: any) {
    event.target.value != '' ? this.isValid = false : this.isValid = true;
    event.target.value != '' ? this.isMessageValidation = false : this.isMessageValidation = true;
    this.validationForm.patchValue({ validationValue: event.target.value.replace(/[^\d]/g, '') });
    if (event.target.value == '') {
      this.isLengthValidation = false;
    } else {
      if (this.selectedWidgetMetaData && this.selectedWidgetMetaData.widgetConfig && this.selectedWidgetMetaData.widgetConfig.validations &&
        this.selectedWidgetMetaData.widgetConfig.validations.length > 0) {
        let validationsList: any = this.selectedWidgetMetaData.widgetConfig.validations;
        const maxLengthFindIndex: any = validationsList.findIndex((v: any) => v.validation_type === 'Maximum Length');
        const minLengthFindIndex: any = validationsList.findIndex((v: any) => v.validation_type === 'Minimum Length');
        const validationValue = Number(this.validationForm.get('validationValue')?.value);
        if ((!/[\d]/.test(event.target.value))) {
          this.isLengthValidation = false;
        }
        else if (this.validationForm.get('selectedValidationType')?.value === 'Maximum Length' && minLengthFindIndex != -1) {
          const minValue = Number(validationsList[minLengthFindIndex]?.validation_value);
          validationValue > minValue ? this.isLengthValidation = false : this.isLengthValidation = true;
        } else if (this.validationForm.get('selectedValidationType')?.value === 'Minimum Length' && maxLengthFindIndex != -1) {
          const maxValue = Number(validationsList[maxLengthFindIndex]?.validation_value);
          validationValue < maxValue ? this.isLengthValidation = false : this.isLengthValidation = true;
        }
      }
    }
  }

  addValidation() {
    if (this.validationForm.get('selectedValidationType')?.value == null) {
      this.isSelectedValidationType = true;
    } else {
      let selectedValidation: any = this.validationForm.get('selectedValidationType')?.value;
      let findIndex: any = this.inputFieldValidationData.findIndex((ele: any) => ele == selectedValidation);

      if (this.validationForm.get('selectedValidationType')?.value === 'Required') {
        if (!this.isMessageValidation) {
          const newValidation: VALIDATION = {
            validation_type: 'Required',
            validation_value: 'true',
            error_message: this.validationForm.get('requiredMessage')?.value,
          };
          this.addOrUpdateValidation(newValidation);
          this.validationForm.get('selectedValidationType')?.reset();
          this.validationForm.get('requiredMessage')?.reset();
        }
      } else {
        this.validationValue = this.validationForm.get('validationValue')?.value;
        (this.validationValue != '') ? this.isMessageValidation = false : this.isMessageValidation = true;
        if (!this.isLengthValidation && !this.isMessageValidation) {
          const newValidation: VALIDATION = {
            validation_type: this.validationForm.get('selectedValidationType')?.value,
            validation_value: this.validationValue,
          };
          this.addOrUpdateValidation(newValidation);
          this.validationForm.get('selectedValidationType')?.reset();
          this.validationForm.get('validationValue')?.setValue('');
        }
      }
      if (!this.isMessageValidation) {
        this.inputFieldValidationData.includes(selectedValidation) ? this.inputFieldValidationData.splice(findIndex, 1) : '';
        this.inputFieldValidationData.length == 0 ? this.showValidationForm = false : '';
      }
    }
  }

  addOrUpdateValidation(newValidation: VALIDATION) {
    if (!this.selectedWidgetMetaData.widgetConfig.validations) {
      this.selectedWidgetMetaData.widgetConfig.validations = [];
    }
    const existingValidationIndex = this.selectedWidgetMetaData.widgetConfig.validations.findIndex(
      (v: any) => v.validation_type === newValidation.validation_type
    );
    if (existingValidationIndex !== -1) {
      if (newValidation.validation_type == 'Required')
        this.selectedWidgetMetaData.widgetConfig.validations[existingValidationIndex].error_message =
          newValidation.error_message;
      else
        this.selectedWidgetMetaData.widgetConfig.validations[existingValidationIndex].validation_value =
          newValidation.validation_value;
    } else {
      this.selectedWidgetMetaData.widgetConfig.validations = [
        ...this.selectedWidgetMetaData.widgetConfig.validations,
        newValidation,
      ];
    }
    this.updateValidation();
    this.editMode = false;
  }



  deleteValidation(index: number) {
    this.showValidationForm = true;
    let validationType: any = this.selectedWidgetMetaData.widgetConfig.validations[index]['validation_type'];
    this.inputFieldValidationData.includes(validationType) ? "" : this.inputFieldValidationData.push(validationType);
    if (this.selectedWidgetMetaData && this.selectedWidgetMetaData.widgetConfig.validations && this.selectedWidgetMetaData.widgetConfig.validations.length > 0) {
      this.selectedWidgetMetaData.widgetConfig.validations.splice(index, 1);
      this.updateValidation();
    }
    if (validationType === 'Maximum Length' || validationType === 'Minimum Length') {
      this.isSelectedValidationType = false;
      this.isValidationExist = false;
      this.isLengthValidation = false;
      this.isValid = false;
    }
  }


  //#region  form section  widgets functionality

  addWidgetForForm() {
    let newInputWidget = { widgetId: 'forminput', key: '', name: 'New Input Field', type: 'text', widgetType: 'input', element: { label: "new field", showLabel: true, placeholderText: 'Enter Text', isRequired: false }, customStyleApplied: false, showDeleteButton: false, style: {} }

    const indexOfTypeButton = this.selectedSectionData.widgets.findIndex(widget => widget.widgetType === 'button');


    if (indexOfTypeButton === -1) {
      this.selectedSectionData.widgets.push(newInputWidget);
    } else {
      this.selectedSectionData.widgets.splice(indexOfTypeButton, 0, newInputWidget);
    }
  }

  setWidgetIndexAndPatchValues(index: number) {
    let widgetData: WIDGET;
    if (index >= 0 && index < this.selectedSectionData.widgets.length) {
      widgetData = this.selectedSectionData.widgets[index];
      if (widgetData.widgetType === 'input') {
        this.sectionWidgetGroup.reset();
        let textColor = (widgetData.style as any)['color'];
        let placeholder;
        let label;
        if (widgetData.element) {
          label = widgetData.element.label;
          placeholder = widgetData.element.placeholderText;
        }
        this.sectionWidgetGroup.patchValue({
          key: widgetData.key,
          textColor: textColor,
          type: widgetData.type,
          label: label,
          placeholder: placeholder
        });
      }
      else {
        this.FormbuttonGroup.reset();
        let textColor = (widgetData.style as any)['color'];
        let bgColor = (widgetData.style as any)['backgroundColor'];
        let width = (widgetData.style as any)['width'];
        let label;
        if (widgetData.element) {
          label = widgetData.element.label;
        }
        this.FormbuttonGroup.patchValue({
          key: widgetData.key,
          textColor: textColor,
          width: width,
          label: label,
          bgColor: bgColor
        });
        this.openedWidgetForm = index;
      }
    } else {
      console.error('Invalid index');
    }
  }

  //#endregion

  //#region widget data update
  getPageById(pageId: string) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_PAGE']);
    apiConfig.postData = { page_id: pageId }
    return this.httpService.placeAPICall(apiConfig);
  }
  //#region menu panel

  private initializeMenuPanelForm(): void {
    this.itemForm = this._formBuilder.group({
      itemArray: this._formBuilder.array([]),
    });

    const itemArray = this.itemForm.get('itemArray') as FormArray;

    this.pagesList.forEach((item) => {
      itemArray.push(
        this._formBuilder.group({
          name: item.pageName,
          pageId: item.pageId,
          isChecked: false,
        })
      );
    });


  }

  get itemControls(): FormGroup[] {
    return (this.itemForm.get('itemArray') as FormArray).controls as FormGroup[];
  }

  toggleWidgetStatus(widget: any, index: any, event: any): void {
    if (!this.checkActualMenu) {
      this.menupaneldetails.widgets[index].widgetConfig['enable'] = event.checked;
      this.selectedPageData.forms.forEach((form: any) => {
        if (form.formConfig.formType == this.formTypes.menuPanel) {
          form = this.menupaneldetails
        }
      })
      this.sharedService.setSelectedPage(this.selectedPageData);
    }
    else {

      widget.widgetConfig['enable'] = event.checked
      let widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': widget.widgetConfig,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': widget.widgetId,
      }
      this.sharedService.updateWidget(widgetPostData, widget.widgetId).subscribe((data: any) => {
      })
      this.menupaneldetails.widgets[index].widgetConfig['enable'] = event.checked;
      this.selectedPageData.forms.forEach((form: any) => {
        if (form.formConfig.formType == this.formTypes.menuPanel) {
          form = this.menupaneldetails
        }
      })
      this.sharedService.setSelectedPage(this.selectedPageData);
    }

  }

  addMenuPanel() {


    let menupanelObj = {

      "formLabel": "menu panel",
      "formKey": "xz1-manuPanel3",
      "formVersion": 2,
      "entityKey": "2324",
      "parentEntityKey": "2e010040-2920-42d5-b057-cfd9fa356b4f",
      "formConfig": {
        "style": {},
        "actions": {},
        "formType": this.formTypes.menuPanel,
        "formsWidgets": [],
        "customStyleApplied": false
      },
      "is_published": false,
      "widgets": []
    }

    if (this.selectedPageData && this.selectedPageData.pageName) {
      menupanelObj.formKey = this.selectedPageData.pageName + this.pageIndex.toString() + '-manuPanel' + this.selectedComponents.length.toString();
    }

    if (!this.hasMenu) {

      let textwidgets: any = [];
      let index = 0;
      let pages = [...this.pagesList]
      pages.push({
        "pageId": "",
        "pageName": "Change Password",
        "open": false
      });
      pages.push({
        "pageId": "",
        "pageName": "Logout",
        "open": false
      })
      pages.forEach((page) => {
        let textwidget = {
          "widgetLabel": "Text",
          "widgetKey": "",
          "widgetType": this.widgetTypes.text,
          "widgetConfig": {
            "style": {
            },
            "enable": false,
            "actions": [
              {
                "action_type": this.widgetActionTypes.navigation,
                "conditional_clause": [
                  {
                    "action": "7ae9e63a-08cf-4b93-ba3d-9c04084737f5",
                    "La6-from0-Te2": [
                      "default"
                    ]
                  }
                ]
              }
            ],
            "element": {},
            "additionalConfig": {},
            "showDeletebutton": true,
            "customStyleApplied": false
          },
          "widgetDataSource": {},
        }
        if (page.pageType == this.pageTypes.changePassword || page.pageType == this.pageTypes.logout) {
          index++;
          textwidget.widgetLabel = page.pageName;
          textwidget.widgetKey = this.selectedPageData.pageName + this.pageIndex.toString() + "-" + "menupanl" + "-" + page.pageName.slice(0, 2) + index;

          textwidgets.push(textwidget);
        }
        else if (page.pageType !== this.pageTypes.loginPage && page.pageType !== this.pageTypes.splashScreen) {
          index++;
          textwidget.widgetLabel = page.pageName;
          textwidget.widgetKey = this.selectedPageData.pageName + this.pageIndex.toString() + "-" + "menupanl" + "-" + page.pageName.slice(0, 2) + index;
          const newObject: any = {
            action: page.pageId,
          };

          newObject[textwidget.widgetKey] = ["default"];

          textwidget.widgetConfig.actions = [{
            "action_type": this.widgetActionTypes.navigation,
            "conditional_clause": [newObject]
          }];
          textwidgets.push(textwidget);
        }
      })

      menupanelObj.widgets = textwidgets;
      this.selectedComponents.push(menupanelObj);
      this.menupaneldetails = menupanelObj;
      this.selectedPageData.forms = this.selectedComponents;
      this.sharedService.setSelectedPage(this.selectedPageData);
    } else {
    }
  }

  async menePanelAdderApical() {

    if (this.selectedWidgetMetaData.widgetConfig.image === "arrow_back") {
      this.sharedService.deleteForm(this.menupaneldetails.formId, this.selectedPageData).subscribe((value: any) => {
        this.sharedService.getPageById(this.selectedPageData.pageId).subscribe((data: any) => {
          this.sharedService.setSelectedPage(data);
        })
      });
    }
    else if (this.selectedWidgetMetaData.widgetConfig.image === "menu") {
      try {
        if (this.checkActualMenu) {

        } else {
          let menupanelSection = {
            key: '',
            sectionId: 'section1',
            name: "menu panel",
            image: 'form',
            sectionType: this.formTypes.menuPanel,
            showDeleteButton: false,
            style: {

            },
            widgets: [],
            isEditable: false,
          }

          let sectionWidgets: any = [];
          this.menupaneldetails.widgets.forEach((widget: any) => {
            let sectionWidget = { widgetId: 'heading1', masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120002", key: '', name: "Text", widgetType: this.widgetTypes.plainText, values: 'Text', showDeleteButton: true, customStyleApplied: false, image: "rich_text", style: {}, actions: [] }
            sectionWidget.name = widget.widgetLabel;
            sectionWidget.key = widget.widgetKey;
            sectionWidget.actions = widget.widgetConfig.actions;
            sectionWidgets.push(sectionWidget);
          })
          menupanelSection.key = this.menupaneldetails.formKey;
          menupanelSection.name = this.menupaneldetails.formLabel;
          menupanelSection.widgets = sectionWidgets;
        }
      } catch (error) {
        console.error('Error fetching page details:', error);
      }
    }
  }
  //#endregion

  onWidgetColorChange(event: any) {
    this.selectedWidgetMetaData.customStyleApplied = true;
    (this.selectedWidgetMetaData.style as any)["color"] = event?.target?.value;
    if (this.page.pageId)
      this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetId, this.selectedWidgetMetaData);
  }

  deleteRadioOption(index: any) {
    if (this.selectedWidgetMetaData?.widgetDataSource?.datasource) {
      this.selectedWidgetMetaData.widgetDataSource.datasource.splice(index, 1);
      this.showRadioValueError = '';
      this.showRadioErrorMessage[index] = false;
      this.isLabelEmpty = false;
    }
  }

  AddRadioOption() {
    const datasource = this.selectedWidgetMetaData?.widgetDataSource?.datasource;
    if (datasource && !datasource.some((item: any) => item.label === "") && this.hasUniqueLabels(datasource)) {
      this.showRadioValueError = '';
      this.selectedWidgetMetaData.widgetDataSource.datasource.push({ key: "", label: "" });
    } else {
      if (!this.hasUniqueLabels(datasource)) {
        this.showRadioValueError = "Please remove dublicate values";
      } else {
        datasource.forEach((item: any, index: number) => {
          item.label == '' ? this.showRadioErrorMessage[index] = true : this.showRadioErrorMessage[index] = false;
        })
        this.showRadioValueError = "";
      }
    }
    this.isLabelEmpty = false
  }

  hasUniqueLabels(list: any): boolean {
    const uniqueNames = new Set<string>();
    for (const obj of list) {
      if (uniqueNames.has(obj.label)) {
        return false;
      }
      uniqueNames.add(obj.label);
    }
    return true;
  }

  updateRadioValue(event: any, itemIndex: number, value: any) {
    event.target.value == '' ? this.showRadioErrorMessage[itemIndex] = true : this.showRadioErrorMessage[itemIndex] = false;
    let newValue = value;
    value.label = event.target.value;
    this.selectedWidgetMetaData.widgetDataSource.datasource[itemIndex] = newValue;
    this.showRadioValueError = ""
    if (this.page.pageId)
      this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetId, this.selectedWidgetMetaData);
  }

  updateWidgetData(form: any, data: any) {
    this.selectedWidgetMetaData.widgetKey = data.key;
    if (this.selectedWidgetMetaData.widgetConfig && data?.placeholder) {
      this.selectedWidgetMetaData.widgetConfig.placeholderText = data?.placeholder;
    }
    if (data.label || data.label == '') {
      this.selectedWidgetMetaData.widgetLabel = data.label
    }
    if (data.title || data.title == '') {
      this.selectedWidgetMetaData.widgetLabel = data.title
    }
    const selectedWidgetMetaData = this.selectedWidgetMetaData;
    if (selectedWidgetMetaData && selectedWidgetMetaData.style) {
      selectedWidgetMetaData.style.color = data.textColor;
    }
    if (data?.textColor !== this.selectedWidgetMetaData.widgetConfig.style.color) {
      this.selectedWidgetMetaData.widgetConfig.customStyleApplied = true;
      (this.selectedWidgetMetaData.widgetConfig?.style as any)["color"] = data.textColor;
    }
    let widgetType = this.selectedWidgetMetaData.widgetType;
    let excludedTypes = [this.widgetTypes.navButton, this.widgetTypes.separator, this.widgetTypes.fingerPrint, this.widgetTypes.faceId];

    if (!excludedTypes.includes(widgetType)) {
      data?.bold ? (this.selectedWidgetMetaData.widgetConfig?.style as any)["font-weight"] = "bold" : (this.selectedWidgetMetaData.widgetConfig?.style as any)["font-weight"] = 'normal'
      data?.italic ? (this.selectedWidgetMetaData.widgetConfig?.style as any)["font-style"] = "italic" : (this.selectedWidgetMetaData.widgetConfig?.style as any)["font-style"] = 'normal'
      data?.underline ? (this.selectedWidgetMetaData.widgetConfig?.style as any)["text-decoration"] = "underline" : (this.selectedWidgetMetaData.widgetConfig?.style as any)["text-decoration"] = 'none'
      data?.fontSize > 0 ? (this.selectedWidgetMetaData.widgetConfig?.style as any)["font-size"] = data?.fontSize + 'px' : (this.selectedWidgetMetaData.widgetConfig?.style as any)["font-size"] = '16px'
    }

    if (data?.bgColor !== this.selectedWidgetMetaData.widgetConfig.style.backgroundColor) {
      this.selectedWidgetMetaData.widgetConfig.customStyleApplied = true;
      (this.selectedWidgetMetaData.widgetConfig?.style as any)["backgroundColor"] = data.bgColor;
    }
    if (data?.matUiType) {
      this.selectedWidgetMetaData.widgetConfig['matUiType'] = data.matUiType;
    }
    if (data?.height) {
      (this.selectedWidgetMetaData.widgetConfig?.style as any)["height"] = data.height + "%";
    }

    if (data?.thickness) {
      (this.selectedWidgetMetaData.widgetConfig?.style as any)["size"] = data.thickness + "px";
    }

    if (this.selectedWidgetMetaData.widgetConfig && data?.image) {
      this.selectedWidgetMetaData.widgetConfig.image = data?.image;
      if (data.image == " ") {
        this.selectedWidgetMetaData.widgetConfig.type = this.iconTpes.noIcon;
      }
      else {
        this.selectedWidgetMetaData.widgetConfig.type = this.iconTpes[data?.image];
      }
    }
    if (this.selectedWidgetMetaData.widgetConfig && data?.type) {
      this.selectedWidgetMetaData.widgetConfig.type = data?.type;
    }
    if (data.value1label && this.selectedWidgetMetaData.widgetConfig.additionalConfig.values) {
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.values[0] = data.value1label
    }
    if (data.value1label && this.selectedWidgetMetaData.widgetConfig.additionalConfig.values) {
      this.selectedWidgetMetaData.widgetConfig.additionalConfig.values[1] = data.value2label
    }

    if (this.page.pageId)
      this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetId, this.selectedWidgetMetaData);
  }

  updateWidgetValues() {
    if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.navButton) {
      this.menePanelAdderApical();
    }
    let widgetPostData = {};
    let tempFlag = false;
    if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.radio) {
      tempFlag = true;
      this.selectedWidgetMetaData.widgetDataSource.datasource.forEach((item: any) => {
        if (item.label == "") {
          this.isLabelEmpty = true
          tempFlag = false;
          return;
        }
      })
      const dataSourceToCheck: any[] = []
      this.selectedWidgetMetaData.widgetDataSource?.datasource?.map((x: any) => {
        dataSourceToCheck.push(x?.label)
      })
      const hasDuplicates = (array: any[]): boolean => {
        const set = new Set<any>();
        for (const item of array) {
          if (set.has(item)) {
            return true;
          }
          set.add(item);
        }
        return false;
      }
      const duplicatesExist = hasDuplicates(dataSourceToCheck);
      if (duplicatesExist) {
        this.toasterService.error("Duplicate Label Exits")
        return;
      }
      widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': this.selectedWidgetMetaData.widgetConfig,
        'widgetDataSource': this.selectedWidgetMetaData.widgetDataSource,
        'widgetLabel': this.selectedWidgetMetaData.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }

    }
    else {
      widgetPostData = {
        'applicationId': this.applicationId,
        'widgetConfig': this.selectedWidgetMetaData.widgetConfig,
        'widgetLabel': this.selectedWidgetMetaData.widgetLabel,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId,
      }
      tempFlag = true;
    }
    if (tempFlag) {
      this.showRadioValueError = "";
      this.sharedService.updateWidget(widgetPostData, this.selectedWidgetMetaData.widgetId).subscribe((data: any) => {
      })
    }
    else {

    }
  }

  updateFormWidgetData(data: any) {
    if (data.label != null) {
      let widgetdata: any = this.selectedSectionData.widgets[this.openedWidgetForm];
      widgetdata.customStyleApplied = true;
      widgetdata.key = data.key;
      widgetdata.type = data.type;
      if (widgetdata.element) {
        widgetdata.element.label = data.label;
      }
      else {
        widgetdata.name = data.label
      }
      (widgetdata.widgetConfig?.style as any)["color"] = data.textColor;
      if (data?.bgColor) {
        (widgetdata.widgetConfig?.style as any)["backgroundColor"] = data.bgColor;
      }
      if (data?.placeholder && widgetdata.element) {
        widgetdata.element.placeholderText = data.placeholder;
      }
      if (data?.width) {
        (widgetdata.widgetConfig?.style as any)["width"] = data.width + "%";
      }
      if (data?.height) {
        (widgetdata.widgetConfig?.style as any)["height"] = data.height + "%";
      }

      if (widgetdata.widgetType !== 'button') {
        if (this.page.pageId)
          this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.openedWidgetForm, widgetdata);
      } else {
        if (this.page.pageId)
          this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, (this.selectedSectionData.widgets.length - 1), widgetdata);
      }
    }
  }

  updateShowMenuStatus(data: any) {
    this.sharedService.setShowMenuStatus(data.showMenu);
  }

  updateSectionData(data: any) {
    this.selectedSectionData.name = data.label;
    this.selectedSectionData.key = data.key;
    (this.selectedSectionData.style as any)["backgroundColor"] = data.bgColor;
  }

  getWidgetColorValue(): string {
    return (this.selectedWidgetMetaData.style as any)["color"];
  }

  updateTableData(){
    this.selectedWidgetMetaData.widgetConfig.tableConfig = this.tableGroup.value;
    this.page.forms.forEach((form:any,index:number) => {
    let widgetIndex =  form.widgets.findIndex((widget:any) => widget.id === this.selectedWidgetMetaData.widgetId);
      if(widgetIndex){
        this.page.forms[index].widgets[widgetIndex] = this.selectedWidgetMetaData;
      }
    })
    this.wformService.setSelectedTableConfig(this.selectedWidgetMetaData.widgetConfig.tableConfig );

    // this.sharedService.setSelectedPage(this.page);
  }

  changeSubscribe() {

    this.textGroup.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((formValue) => {
        if (
          this.selectedWidgetMetaData.widgetType === this.widgetTypes.plainText
        ) {
          this.updateWidgetData(this.textGroup, formValue);
        }
      });

    this.navTextGroup.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((formValue) => {
        if (
          this.selectedWidgetMetaData.widgetType == this.widgetTypes.navText
        ) {
          this.updateWidgetData(this.navTextGroup, formValue);
        }
      });

    this.textFieldGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.textbox) {
          this.updateWidgetData(this.textFieldGroup, formValue);
        }
      });

    this.addressGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.address) {
          this.updateWidgetData(this.addressGroup, formValue);
        }
      });

    this.selectGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.dropdown || this.selectedWidgetMetaData.widgetType === this.widgetTypes.searchableDropdown) {
          this.updateWidgetData(this.selectGroup, formValue);
        }
      });

    this.filePickerGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.filePicker) {
          this.updateWidgetData(this.filePickerGroup, formValue);
        }
      });

    this.imagePickerGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.image) {
          this.updateWidgetData(this.imagePickerGroup, formValue);
        }
      });

    this.buttonGroup.valueChanges.pipe(
      debounceTime(100),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.button) {
          this.updateWidgetData(this.buttonGroup, formValue);
        }
      });

    this.navButtonGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.navButton) {
          this.updateWidgetData(this.buttonGroup, formValue);
        }
      });

    this.showMenuGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        this.updateShowMenuStatus(formValue);
      });

    this.checkBoxGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.singleselectcheckbox) {
          this.updateWidgetData(this.checkBoxGroup, formValue);
        }
      });

    this.radioButtonGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.radio) {
          this.updateWidgetData(this.radioButtonGroup, formValue);
        }
      });

    this.dataPickerGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.date) {
          this.updateWidgetData(this.dataPickerGroup, formValue);
        }
      });


    this.geoGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.geotag) {
          this.updateWidgetData(this.geoGroup, formValue);
        }
      });

    this.separatorGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.separator) {
          this.updateWidgetData(this.separatorGroup, formValue);
        }
      });

    this.imageUploaderGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.imageUploader) {
          this.updateWidgetData(this.imageUploaderGroup, formValue);
        }
      });

    this.faceIdGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.faceId) {
          this.updateWidgetData(this.faceIdGroup, formValue);
        }
      });

    this.touchIdGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.fingerPrint) {
          this.updateWidgetData(this.touchIdGroup, formValue);
        }
      });

    this.sectionGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {

        this.updateSectionData(formValue);
      });

    this.definedFormGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {

        this.updateSectionData(formValue);
      });

    this.sectionWidgetGroup.valueChanges.pipe(
      debounceTime(150),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        this.updateFormWidgetData(formValue);
      });
    this.FormbuttonGroup.valueChanges.pipe(
      debounceTime(150),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        this.updateFormWidgetData(formValue);
      });

    this.scannerGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.scanner) {
          this.updateWidgetData(this.scannerGroup, formValue);
        }
      });

    this.tableGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    )
      .subscribe((formValue) => {
        if (this.selectedWidgetMetaData.widgetType === this.widgetTypes.table) {
          this.updateTableData();
        }
      });

    this.dataListGroup.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
    ).subscribe((formValue) => {
      this.updateDataListWidget(formValue);

    })

    this.valuesForm.valueChanges.subscribe((data: any) => {
      this.lableExisted = false;
    })

  }

  updateValidation() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
    apiConfig.postData = {
      'applicationId': this.applicationId,
      'widgetConfig': this.selectedWidgetMetaData.widgetConfig,
      'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
      'widgetId': this.widgetId
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
      },
      error: (err: any) => {
      }
    })
  }


  addSubFormAction() {
    if (this.subFormAction.valid) {
      let label = this.selectedWidgetMetaData.widgetKey;
      const newObject: any = {
        action: this.subFormAction.get('action')?.value
      };
      newObject[label] = this.subFormAction.get('value')?.value;
      this.subFormActionsList.push(newObject);
      this.subFormAction.reset();
    }
  }

  fieldsGenerator() {
    this.fieldWigets = [];
    let value = this.selectedComponents[this.sectionIndex];

    value.widgets.forEach((widget: any) => {
      if (widget.widgetType !== this.widgetTypes.button) {
        this.fieldWigets.push({ parameters: "", action: "", key: widget.widgetKey, name: widget.widgetLabel, values: [] })
      }
    })
  }

  addFieldCondition(index: number, name: any) {
    this.NavigationConditionals.push({ key: name, values: [] });
    this.formWidgetsMenu.splice(index, 1);
  }

  addLitsItem(i: number) {
    if (this.singleInputField.valid) {
      this.fieldWigets[i].values.push(this.singleInputField.get('value')?.value);
      this.singleInputField.reset();
    }
  }

  addNavigationAction() {
    if (this.conditionNavigationAciton.valid) {
      let selectAction = this.conditionNavigationAciton.get('action')?.value;
      this.pageNamesandIdList.forEach((obj) => {
        if (obj.label == selectAction) {
          selectAction = obj.key;
        }
      })
      const newObject: any = {
        action: selectAction,
        parameters: this.conditionNavigationAciton.get('parameters')?.value || '',
      };
      this.fieldWigets.forEach((value) => {
        newObject[value.key] = value.values;
      })
      this.finalnavgationActionList.push(newObject);
      this.uinavgationActionList.push({ name: this.conditionNavigationAciton.get('action')?.value, obj: newObject });
      this.removeListItem(this.conditionNavigationAciton.get('action')?.value, this.pageNames);
    }
    this.conditionNavigationAciton.reset();
  }

  removeListItem(item: string, array: any): [] {
    const index = array.indexOf(item);
    if (index !== -1) {
      array.splice(index, 1);
    }
    return array;
  }

  removeNavigationAction(index: number, obj: any) {
    this.finalnavgationActionList.splice(index, 1);
    this.selectedComponents.forEach((form) => {
      if (form.formKey === obj.action) {
        this.conditionalFormList.push(form.formLabel);
      }
    })
    this.pageNames.push(obj.action)
  }

  addFieldConditionUpdate(index: number, name: any) {
    this.conditionalKeyValue.push({ key: name.widgetKey, values: [] });
    this.formWidgetsMenuUpdate.splice(index, 1);
  }

  setConditionalValue(item: any, index: any) {
    this.conditionalActionUpdatedGroup.patchValue({
      pageName: item.action,
    })
    let values: any[] = [];
    item.parameters.forEach((itemP: any) => {
      this.csWidgetsList.forEach((widget: any) => {
        if (widget.widgetKey == itemP) {
          values.push(widget.widgetLabel);
        }
      })
    })

    this.msFieldslistUpdate = values;
    this.formWidgetsUpdate = this.formWidgets;

    const widgetLabelsToRemove = this.msFieldslistUpdate.map(item => item.widgetLabel);
    this.formWidgetsUpdate = this.formWidgetsUpdate.filter(widget => {
      return !widgetLabelsToRemove.includes(widget.widgetLabel);
    });

    this.conditionalKeyValue = Object.entries(item).filter(([key]) => key !== "action" && key !== "parameters")
      .map(([key, values]) => ({ key, values }));

    this.formWidgetsMenuUpdate = this.formWidgetsMenu;

    this.formWidgetsMenuUpdate = this.formWidgetsMenuUpdate.filter(itemMenu =>
      !this.conditionalKeyValue.some(itemConditional => itemConditional.key === itemMenu.widgetKey));
  }


  getLabelName(key: any) {
    const matchingWidget = this.formWidgets.find((widget: any) => widget.widgetKey === key);
    if (matchingWidget) {
      return matchingWidget.widgetLabel;
    }
    return '';
  }

  removeParameterUpdate(field: any, index: any) {
    if (index >= 0) {
      this.msFieldslistUpdate.splice(index, 1);
      this.formWidgetsUpdate.push(field);
    }
  }


  selectedParameterUpdate(event: MatAutocompleteSelectedEvent): void {
    if (this.msFieldslistUpdate) {
      let value = event.option.value;
      if (!this.msFieldslistUpdate.includes(value)) {
        this.formWidgetsUpdate = this.formWidgetsUpdate.filter((item: any) => item !== value);
        this.msFieldslistUpdate.push(value);
      }
      this.payloadInput.nativeElement.value = '';
      this.fieldCtrl.setValue(null);
    }
    else {
      this.msFieldslistUpdate = []
      this.msFieldslistUpdate.push(event.option.viewValue);
      this.formWidgetsUpdate = this.formWidgetsUpdate.filter((item: any) => item !== event.option.viewValue)
      this.payloadInput.nativeElement.value = '';
      this.fieldCtrl.setValue(null);
    }
  }

  delectChipGridItemUpdateChip(index: any, key: any) {
    this.conditionalKeyValue.splice(index, 1);
    const matchingWidget = this.formWidgets.find((widget: any) => widget.widgetKey === key);
    this.formWidgetsMenuUpdate.push(matchingWidget);
  }

  removeItemValueUpdateChip(item: any, itemIndex: any, index: any) {
    this.conditionalKeyValue[itemIndex].values.splice(index, 1);

    const matchingWidget = this.formWidgets.find((widget: any) => widget.widgetKey === item.key);
    if (matchingWidget) {
      this.dropdownValuesUpdateChip = matchingWidget.widgetDataSource.datasource;
      this.dropdownValuesUpdateChip = this.dropdownValuesUpdateChip.filter(data => {
        return !item.values.includes(data.label)
      })
    } else {
      this.dropdownValuesUpdateChip = [];
    }
  }

  addUpdateChip(event: MatChipInputEvent): void {
  }

  onInputClickUpdateChip(item: any, index: any) {
    const matchingWidget = this.formWidgets.find((widget: any) => widget.widgetKey === item.key);
    if (matchingWidget) {
      this.dropdownValuesUpdateChip = matchingWidget.widgetDataSource.datasource;
      this.dropdownValuesUpdateChip = this.dropdownValuesUpdateChip.filter(data => {
        return !item.values.includes(data.label)
      })
    } else {
      this.dropdownValuesUpdateChip = [];
    }
  }

  selectedUpdateChip(event: MatAutocompleteSelectedEvent, index: any): void {
    if (this.conditionalKeyValue) {
      this.conditionalKeyValue[index].values.push(event.option.value.label);
      this.dropdownValuesUpdateChip = this.dropdownValuesUpdateChip.filter(item => item.label !== event.option.value.label)
    }
  }

  updateConditionalActions(actionType: any, index: any) {
    let actionList = this.selectedWidgetMetaData.widgetConfig.actions;
    if (actionType == this.widgetActionTypes.conditionalNavigation) {
      const newObject: any = {
        action: this.conditionalActionUpdatedGroup.get('pageName')?.value,
        parameters: this.msFieldslistUpdate ? this.msFieldslistUpdate : [],
      };

      this.conditionalKeyValue.forEach((value) => {
        newObject[value.key] = value.values
      })

      this.listOfconditionalActions[index] = newObject;
      let existingSubformActionIndex = -1;

      if (actionList.length > 0) {
        existingSubformActionIndex = actionList.findIndex((action: any) => action.action_type === this.widgetActionTypes.conditionalNavigation);
      }
      if (existingSubformActionIndex !== -1) {
        actionList[existingSubformActionIndex].conditional_clause = [...this.listOfconditionalActions];
        this.updateActions([...actionList], this.widgetActionTypes.conditionalNavigation);
      }
    }
  }

  addCondiotionAction(actionList: any) {
    //checking if already list exists
    if (!this.listOfconditionalActions) {
      this.listOfconditionalActions = [];
    }
    //conditional field lists
    let values: any[] = [];
    this.msFieldslist.forEach((widget: any) => {
      values.push(widget.widgetKey);
    })
    const newObject: any = {
      action: this.conditionalActionGroup.get('pageName')?.value,
      parameters: values.length > 0 ? values : [],
    };
    this.NavigationConditionals.forEach((value) => {
      newObject[value.key.widgetKey] = value.values
    })
    this.listOfconditionalActions.push(newObject);

    // checking if action exists and updating actions
    let existingSubformActionIndex = -1;
    if (actionList.length > 0) {
      existingSubformActionIndex = actionList.findIndex((action: any) => action.action_type === 'subform');
    }
    if (existingSubformActionIndex !== -1) {
      actionList[existingSubformActionIndex].conditional_clause = [...this.listOfconditionalActions];
      this.updateActions([...actionList], this.widgetActionTypes.conditionalNavigation);
    } else {
      const newSubformAction = {
        action_type: 'subform',
        conditional_clause: [...this.listOfconditionalActions],
      }
      actionList.length > 0 ? this.updateActions([...actionList, newSubformAction], this.widgetActionTypes.conditionalNavigation) : this.updateActions([newSubformAction], this.widgetActionTypes.conditionalNavigation);
    };

    this.msFieldslist = [];
    this.NavigationConditionals = [];
    this.formWidgetsMenu = [];
    this.selectedComponents[this.sectionIndex]?.widgets.forEach((widget: any) => {
      if (widget.widgetType !== this.widgetTypes.button) {
        this.formWidgets.push(widget);
        if (widget.widgetType == this.widgetTypes.dropdown || widget.widgetType == this.widgetTypes.radio || widget.widgetType == this.widgetTypes.singleselectcheckbox)
          this.formWidgetsMenu.push(widget);
      }

      this.NavigationConditionals = [];
    })
    //updating the form group
    this.conditionalActionGroup.reset();
    this.conditionalActionGroup.get('pageName')?.setErrors(null);
    this.conditionalActionGroup.get('pageName')?.markAsUntouched();
  }

  addDefaultNavigationAction(actionList: any) {
    //checking valid form group
    if (this.navigationGroup.valid) {
      const pageKey = this.pagesList.find((page) => page.pageName === this.navigationGroup.get('pageName')?.value)?.pageId;
      // creating obj for navigation action
      const newObject: any = {
        action: pageKey,
      };
      newObject[this.selectedWidgetMetaData.widgetKey] = ["default"];

      //checking if actions exists  and updating the actions 
      let existingNavigationIndex = -1;
      if (actionList.length > 0) {
        existingNavigationIndex = actionList.findIndex((action: any) => action.action_type === this.widgetActionTypes.navigation);
      }
      if (existingNavigationIndex !== -1) {
        actionList[existingNavigationIndex] = {
          "action_type": this.widgetActionTypes.navigation,
          "conditional_clause": [newObject]
        };
        this.updateActions([...actionList], this.widgetActionTypes.navigation);
      }
      else {
        const actions = {
          "action_type": this.widgetActionTypes.navigation,
          "conditional_clause": [newObject]
        }
        actionList.length > 0 ? this.updateActions([...actionList, actions], this.widgetActionTypes.navigation) : this.updateActions([actions], this.widgetActionTypes.navigation);

      }
    }
  }

  async addSubmitAction(actionList: any) {
    await this.addOrDeletePreviewPage();
    this.apiForm.patchValue({
      apiUrl: "dummyurl",
      method: "Post",
    })
    if (this.apiForm.valid) {
      let existingSubmitIndex = -1;
      if (actionList.length > 0) {
        existingSubmitIndex = actionList.findIndex((action: any) => action.action_type === 'Api-trigger');
      }
      // making api call to check api for submit action
      let dataSource = await this.actionDataSourceAdd();
      //cheking if action exists and updating the actions
      if (existingSubmitIndex !== -1) {
        actionList[existingSubmitIndex] = {
          "action_type": "Api-trigger",
          "conditional_clause": []
        };
        this.updateActions([...actionList], 'Submit', dataSource);
      }
      else {
        const actions = {
          "action_type": "Api-trigger",
          "conditional_clause": []
        }
        actionList.length > 0 ? this.updateActions([...actionList, actions], 'Submit', dataSource) : this.updateActions([actions], 'Submit', dataSource);
      }
    }
  }

  async addActions(actionType: any) {
    if (!this.selectedWidgetMetaData.widgetConfig.actions) {
      this.selectedWidgetMetaData.widgetConfig.actions = [];
    }
    let actionList = this.selectedWidgetMetaData.widgetConfig.actions;
    if (actionType == this.widgetActionTypes.conditionalNavigation) {
      if (this.conditionalActionGroup.get('pageName')?.value != null) {
        this.addCondiotionAction(actionList);
      } else {
        this.conditionalActionGroup.get('pageName')?.setValidators(Validators.required);
        this.conditionalActionGroup.get('pageName')?.updateValueAndValidity();
        this.conditionalActionGroup.get('pageName')?.markAllAsTouched;
      }
    }
    else if (actionType == this.widgetActionTypes.navigation) {
      this.addDefaultNavigationAction(actionList);
    }
    else if (actionType == this.widgetActionTypes.submit) {
      await this.addSubmitAction(actionList);
    }
  }

  updateActions(actions: any, actionType: any, dataSource?: any) {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
    this.widgetMetaEntire.widgetMeta.widgetConfig['actions'] = actions;
    if (actionType === this.widgetActionTypes.submit) {
      apiConfig.postData = {
        'applicationId': this.applicationId,
        'widgetConfig': this.widgetMetaEntire?.widgetMeta.widgetConfig,
        'widgetDataSource': dataSource,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId
      }
    } else {
      apiConfig.postData = {
        'applicationId': this.applicationId,
        'widgetConfig': this.widgetMetaEntire?.widgetMeta.widgetConfig,
        'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
        'widgetId': this.widgetId
      }
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.toasterService.success('Action Updated Successfully');
      },
      error: (err: any) => {
      }
    })
  }

  deleteConditionalAction(index: any, action: any) {
    const subformIndex = this.selectedWidgetMetaData.widgetConfig.actions.findIndex(
      (action: any) => action.action_type === 'subform'
    );
    if (subformIndex !== -1) {
      const conditionalClauseArray = this.selectedWidgetMetaData.widgetConfig.actions[subformIndex].conditional_clause;

      if (index >= 0 && index < conditionalClauseArray.length) {
        if (conditionalClauseArray.length == 1 && index == 0) {
          const filteredActions = this.selectedWidgetMetaData.widgetConfig.actions.filter(
            (action: any) => action.action_type !== 'subform'
          );
          this.selectedWidgetMetaData.widgetConfig.actions = filteredActions;
          this.selectedActions.splice(subformIndex, 1);
          this.buttonActions.push(action);
        }
        else {
          conditionalClauseArray.splice(index, 1);
          this.selectedWidgetMetaData.widgetConfig.actions[subformIndex].conditional_clause = conditionalClauseArray;
        }
        this.listOfconditionalActions.splice(index, 1);
      }
      this.updateActions(this.selectedWidgetMetaData.widgetConfig.actions, action);
    }
  }

  async deleteAction(index: any, action: any) {
    if (
      this.selectedWidgetMetaData.widgetConfig &&
      this.selectedWidgetMetaData.widgetConfig.actions &&
      this.selectedWidgetMetaData.widgetConfig.actions.length > 0
    ) {
      if (action === this.widgetActionTypes.navigation) {
        const filteredActions = this.selectedWidgetMetaData.widgetConfig.actions.filter(
          (action: any) => action.action_type !== this.widgetActionTypes.navigation
        );
        this.selectedWidgetMetaData.widgetConfig.actions = filteredActions;
      }
      else if (action === this.widgetActionTypes.submit) {
        const filteredActions = this.selectedWidgetMetaData.widgetConfig.actions.filter(
          (action: any) => action.action_type !== 'Api-trigger'
        );
        this.selectedWidgetMetaData.widgetConfig.actions = filteredActions;
        this.selectedWidgetMetaData.widgetConfig['previewPageId'] ? await this.deletePreviewScreen() : null;
      }
      else {
        const filteredActions = this.selectedWidgetMetaData.widgetConfig.actions.filter(
          (action: any) => action.action_type !== 'subform'
        );
        this.selectedWidgetMetaData.widgetConfig.actions = filteredActions;
        this.listOfconditionalActions = [];
      }
    }
    this.updateActions(this.selectedWidgetMetaData.widgetConfig.actions, action);

    this.selectedActions.splice(index, 1);
    this.actionForm.get('selectedAction')?.setValue('');
    this.buttonActions.push(action);
  }


  //#region  data source 

  deleteDatasourceValue(i: number) {
    this.dataSourceValues.splice(i, 1);
  }

  removeDataSource(index: number) {
    const dataSourceArray = this.valuesForm.get('dataSource') as FormArray;
    dataSourceArray.removeAt(index);
  }

  addDataSourceValue() {
    if (!this.dataSourceValues) {
      this.dataSourceValues = [];
    }
    if (this.valuesForm.get('label')?.value !== '' && this.valuesForm.get('label')?.value !== null) {
      const newValue = this.valuesForm.get('label')?.value;
      if (!this.dataSourceValues.includes(newValue)) {
        this.dataSourceValues.push(newValue);
        this.lableExisted = false;
        this.valuesForm.get('label')?.reset();

      } else {
        this.lableExisted = true;
      }
      this.requiredField = false;
    } else {
      this.requiredField = true;
    }
  }

  updateDataSource(value: any) {
    if (this.apiForm.valid) {
      const apiUrl = value['apiUrl'];
      const method = value['method'];
      const payload = this.msFieldslist ? this.msFieldslist : [];
      const responseParameter = value['responseParameter'];
      const authApiUrl = value['authApiUrl'];
      const authType = value['auth'];
      const apiKey = value['apiKey'];

      let dataSource = {
        "datasourceType": "api",
        "datasource": apiUrl,
        "request-parameter": payload,
        "response-parameter": responseParameter,
        "method": method,
        "Authorization": {
          "auth-api-url": authApiUrl,
          "auth": authType,
          "api-key": apiKey,
        }
      }

      this.selectedWidgetMetaData.widgetDataSource = dataSource;
      this.makeApiCall();

      if (this.page.pageId)
        this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetId, this.selectedWidgetMetaData);
    }
  }

  makeAuthApiCall() {
    const authApiUrl = this.AuthApiGroup.get('authApiUrl')?.value;
    const auth = this.AuthApiGroup.get('auth')?.value;
    let requestPayload = {};

    if (this.authApiuserCreds.valid) {
      requestPayload = {
        userName: this.authApiuserCreds.get('authUsername')?.value,
        password: this.authApiuserCreds.get('authPassword')?.value,
      }
    } else if (this.authApiEmailCreds.valid) {
      requestPayload = {
        email: this.authApiEmailCreds.get('authEmail')?.value,
        password: this.authApiEmailCreds.get('authPassword')?.value,
      }
    } else if (auth === 'key') {

    }

    this.makeAuthRequest(authApiUrl, {
      method: 'POST',
      body: JSON.stringify(requestPayload),
      headers: {
        'Content-Type': 'application/json',
      },
    }).subscribe((responce: any) => {
    });

  }

  makeAuthRequest(authUrl: any, options: any): Observable<any> {
    return new Observable(observer => {
      fetch(authUrl, options)
        .then(response => {
          if (!response.ok) {
            this.authApiStatus = response.status;
          }
          else {
            this.authResposeData = response;
            this.authApiStatus = response.status;
          }
          return response.json();
        })
        .then(data => {
          this.authResposeData = data;
          this.fetchKeysFromAuthAPI(data);
        })
        .catch(error => {
          this.authResposeData = error;
          observer.error(error);
          observer.complete();
        });
    });
  }

  loginAndFetchProfile(AuthUrl: any, payload: any, urlApi: any, method: any, tokenField?: any): Observable<any> {

    const body = { ...payload };

    return this.makeLoginRequest(AuthUrl, urlApi, method, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
      },
    }, tokenField).pipe(
      catchError(error => {
        console.error('Login Error:', error);
        return throwError(error);
      })
    );
  }

  makeLoginRequest(Authurl: string, urlApi: any, method: any, options: any, tokenField?: any,): Observable<any> {
    return new Observable(observer => {
      fetch(Authurl, options)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          const accessToken = data[tokenField];
          this.makeProfileRequest(urlApi, method, accessToken).subscribe(
            (profileData: any) => {
              observer.next(profileData);
              observer.complete();
            },
            (profileError: any) => {
              observer.error(profileError);
              observer.complete();
            }
          );
        })
        .catch(error => {
          observer.error(error);
          observer.complete();
        });
    });
  }

  makeProfileRequest(url: any, method: any, accessToken: string): Observable<any> {
    const profileUrl = `/profile`;
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    });

    return new Observable(observer => {
      fetch(url, {
        method: method,
        headers,
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(profileData => {

          this.fetchKeysFromAPI(profileData);

          if (Array.isArray(profileData)) {
            // this.sharedService.setDataSourceApiValues({ widgetId:this.selectedWidgetMetaData.widgetId,responce: profileData, field: this.apiForm.get('responseParameter')?.value });
          } else {
            this.toasterService.warning('The Api Does not return list of values');
          }
          observer.next(profileData);
          observer.complete();
        })
        .catch(profileError => {
          observer.error(profileError);
          observer.complete();
        });
    });
  }

  fetchKeysFromAPI(data: any) {
    if (Array.isArray(data)) {
      this.apikeys = Object.keys(data[0]);
    }
    else if (data) {
      this.apikeys = Object.keys(data);

    }
  }

  fetchKeysFromAuthAPI(data: any) {
    if (Array.isArray(data)) {
      this.authApikeys = Object.keys(data[0]);
    }
    else if (data) {
      this.authApikeys = Object.keys(data);

    }
  }


  makeApiCall() {
    try {
      const apiUrl = this.apiForm.get('apiUrl')?.value;
      const method = this.apiForm.get('method')?.value;
      const payload = this.msFieldslist ? this.msFieldslist : [];
      const responseParameter = this.apiForm.get('responseParameter')?.value;
      let authApiUrl = '';
      let apiKey = '';

      let headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });

      const requestData = { payload };

      if (this.authApiData.authApiUrl) {

        authApiUrl = this.authApiData.authApiUrl;
        apiKey = this.authApiData?.authTokenField;
        let requestPayload = {};
        if (this.authApiData.auth === 'user') {
          requestPayload = {
            username: this.authApiData.userName,
            password: this.authApiData.password,
          }
        } else if (this.authApiData.auth === 'email') {
          requestPayload = {
            email: this.authApiData.email,
            password: this.authApiData.password,
          }
        } else if (this.authApiData.auth === 'key') {

        }
        this.loginAndFetchProfile(authApiUrl, requestPayload, apiUrl, method, apiKey).subscribe(
          (profileResponse: any) => {
            console.log("Profile Response:", profileResponse);
          },
          (error: any) => {
            console.error("Error:", error);
          }
        );
      } else {
        this.makeApiRequest(apiUrl, method, requestData, headers);
      }


    }
    catch (error: any) {
      this.handleApiError(error);
    }
  }



  makeApiRequest(apiUrl: string, method: string, requestData: any, headers: HttpHeaders): void {
    switch (method) {
      case 'GET':
        this.http.get(apiUrl, { headers }).subscribe(
          (response) => {
            this.fetchKeysFromAPI(response);

            if (Array.isArray(response)) {
              // this.sharedService.setDataSourceApiValues({ widgetId:this.selectedWidgetMetaData.widgetId,responce: response, field: this.apiForm.get('responseParameter')?.value });
            } else {
              this.toasterService.warning('The Api Does not return list of values');
            }
          },
          (error) => {
            this.handleApiError(error);
          }
        );
        break;
      case 'POST':
        this.http.post(apiUrl, requestData, { headers }).subscribe(
          (response) => {
            console.log(response);
          },
          (error) => {
            this.handleApiError(error);
          }
        );
        break;
      case 'PUT':
        this.http.put(apiUrl, requestData, { headers }).subscribe(
          (response) => {
            console.log(response);
          },
          (error) => {
            this.handleApiError(error);
          }
        );
        break;
      case 'DELETE':
        this.http.delete(apiUrl, requestData).subscribe(
          (response) => {
            console.log(response);
          },
          (error) => {
            this.handleApiError(error);
          }
        );
        break;
      default:
        throw new Error('Invalid HTTP method');
    }
  }

  handleApiError(error: any): void {
    if (error.status === 0) {

      this.toasterService.error('CORS error: Unable to make the API call due to cross-origin restrictions.');

    } else {
      this.toasterService.error(error.message);
    }
  }

  async addOrDeletePreviewPage() {
    let preview = this.previewGroup.get('preview')?.value ? this.previewGroup.get('preview')?.value : false;
    let checkPreviewPageInWidget = this.selectedWidgetMetaData.widgetConfig['previewPageId'];
    let previewPageIndex = -1;
    isNullOrUndefined(checkPreviewPageInWidget) ? previewPageIndex = -1 : previewPageIndex = this.pagesList.findIndex((page: any) => page.pageId === checkPreviewPageInWidget);
    if (preview && isNullOrUndefined(checkPreviewPageInWidget)) {
      await this.fetchPreviewScreen();
    } else if (preview == false && previewPageIndex >= 0) {
      await this.deletePreviewScreen();
    }
  }

  async actionDataSourceAdd(): Promise<any> {
    let dataSource = {};
    let values: string[] = [];
    this.msFieldslist.forEach((field) => {
      values.push(field.widgetKey);
    })
    let preview = this.previewGroup.get('preview')?.value ? this.previewGroup.get('preview')?.value : false;
    dataSource = {
      "datasourceType": "api",
      "datasource": this.apiForm.get('apiUrl')?.value,
      "request-parameter": values,
      "response-parameter": this.apiForm.get('responseParameter')?.value ? { label: this.apiForm.get('responseParameter')?.value } : null,
      "method": this.apiForm.get('method')?.value,
      "preview": preview,
      "Authorization": {
        "auth-api-url": this.apiForm.get('authApiUrl')?.value ? this.apiForm.get('authApiUrl')?.value : "",
        "auth": this.apiForm.get('auth')?.value ? this.apiForm.get('auth')?.value : "",
        "api-key": this.apiForm.get('apiKey')?.value ? this.apiForm.get('apiKey')?.value : "",
      }
    }
    // this.makeApiCall();
    return dataSource;
  }



  addDataSource(isChartApiRequest?:boolean,selectedApiId?:string,type?:string) {
    const selectedType = this.dataSourceTypeForm.get('dataSourceType')?.value;
    let dataSource;

    if(isChartApiRequest){
      dataSource = {
        "datasourceType": type,
        "datasource": selectedApiId,
      }
    }
    else if ((selectedType &&selectedType.toLowerCase() === 'api') ) {

      this.makeApiCall();
      let values: string[] = [];
      this.msFieldslist.forEach((field) => {
        values.push(field.widgetKey);
      })

      let apiId = this.apiForm.get('apiId')?.value;
      let selectedApi = this.userApis.find((api:any) => api.apiId === apiId);
      let authApi;
      selectedApi?.authenticatedApiId != null ? authApi = this.authApis.find((api:any) => api.apiId === selectedApi.authenticatedApiId) : null;
      
      dataSource = {
        "datasourceType": "api",
        "datasource": selectedApi.apiURL,
        "apiId":selectedApi.apiId,
        "request-parameter": values,
        "response-parameter": this.apiForm.get('responseParameter')?.value ? { label: this.apiForm.get('responseParameter')?.value } : null,
        "method": selectedApi.method,
        "Authorization":authApi ?  {
          "auth-api-url": authApi?.apiURL,
          "auth": authApi?.authType,
          "api-key": "access_token",
        } : {}
      }

    } else if (selectedType.toLowerCase() === 'manual') {
      let newManualValues: { key: string, label: string }[] = [];

      this.dataSourceValues.forEach((value) => {
        newManualValues.push({ key: '', label: value });
      })
      dataSource = {
        "datasourceType": "manual",
        "datasource": [...newManualValues],
      }
    }

    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_EDIT_WIDGET']);
    this.widgetMetaEntire.widgetMeta['widgetDataSource'] = dataSource
    apiConfig.postData = {
      'applicationId': this.applicationId,
      'widgetDataSource': dataSource,
      'userId': JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
      'widgetId': this.widgetId
    }
    this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
        this.toasterService.success('Actions Updated Successfully');
      },
      error: (err: any) => {
        this.toasterService.error('Something Went wrong Try again');
      }
    })
  }

  onFileSelected(event: any) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      this.imageUploaderPhoto = selectedFile;
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;

        image.onload = () => {

          this.imageUploaderSrc = e.target.result;
          const binaryData = e.target.result.split(',')[1];
          this.selectedWidgetMetaData.widgetConfig.image = binaryData;
          if (this.page.pageId) {
            let widgetId = this.selectedWidgetMetaData.widgetId;
            let updating = false;
            const image = this.selectedWidgetMetaData.widgetConfig.image ? this.selectedWidgetMetaData.widgetConfig.image : '';
            image.includes('mobiwise.s3') ?  updating = true : updating = false;
            const parts: string[] = image.split('/');
            this.sharedService.updateWidgetImage(selectedFile, widgetId,updating ? parts[parts.length - 1]:undefined ).subscribe((data: any) => {
              this.selectedWidgetMetaData.widgetConfig.image = data.image;
              this.selectedWidgetMetaData['image'] = data.image +'?time='+new Date().getTime();
              this.s3ImageUrl = data.image +'?time='+new Date().getTime();
            });
          }
        }
      }
      reader.readAsDataURL(selectedFile);
    }
  }

  cropImage(){
    const dialogRef =  this.dialog.open(ImageCropperComponent,{
      disableClose: true,
      data: {
       imageUrl:this.s3ImageUrl
     }
   })

   dialogRef.afterClosed().subscribe(result => {

     if (typeof (result) !== 'boolean' && result !== undefined) {
       if (this.page.pageId) {
        let widgetId = this.selectedWidgetMetaData.widgetId;
        let updating = false;
        const image = this.selectedWidgetMetaData.widgetConfig.image ? this.selectedWidgetMetaData.widgetConfig.image : '';
        image.includes('mobiwise.s3') ?  updating = true : updating = false;
        const parts: string[] = image.split('/');
        this.sharedService.updateWidgetImage(result.croppedImageFile, widgetId,updating ? parts[parts.length - 1]:undefined ).subscribe((data: any) => {
          this.selectedWidgetMetaData.widgetConfig.image = data.image;
          this.selectedWidgetMetaData['image'] = data.image +'?time='+new Date().getTime();
          this.s3ImageUrl = data.image +'?time='+new Date().getTime();
        });
      }
     }
   });
 }





  getImageFile(binaryImage: any) {
    if (binaryImage == 'image' || binaryImage == undefined) {
      return this.imageUploaderSrc;
    }else if(binaryImage.includes('mobiwise.s3')){
      return binaryImage+'?time=' + new Date().getTime();
    }else {
      let imageSrc = 'data:image/png;base64,';
      imageSrc = imageSrc + binaryImage;
      return imageSrc;
    }
  }


  //#region chips multi select add values

  // multi select enter values in conditional action
  addItemValue(item: any, event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      item.values.push({ name: value });
    }

    event.chipInput!.clear();
  }

  removeItemValue(value: string, item: any): void {
    const index = item.values.indexOf(value);

    if (index >= 0) {
      item.values.splice(index, 1);
    }
  }

  editItemValue(value: string, item: any, event: MatChipEditedEvent) {
    const valueItem = event.value.trim();

    if (!valueItem) {
      this.removeItemValue(value, item);
      return;
    }
    const index = item.values.indexOf(value);
    if (index >= 0) {
      item.values[index] = valueItem;
    }
  }

  delectChipGridItem(index: any, item: any) {
    this.NavigationConditionals.splice(index, 1);
    this.formWidgetsMenu.push(item.key);
  }
  patchStyleProperties(form: any, widget: any) {
    form.patchValue({
      bold: widget?.widgetConfig?.style["font-weight"] != 'bold' ? false : true,
      italic: widget?.widgetConfig?.style["font-style"] != 'italic' ? false : true,
      underline: widget?.widgetConfig?.style["text-decoration"] != 'underline' ? false : true,
      fontSize: !isNullOrUndefined(widget?.widgetConfig?.style?.["font-size"]) && widget?.widgetConfig?.style?.["font-size"] != 'none' ? parseInt(widget?.widgetConfig?.style?.["font-size"]) : 16
    })
  }
  //#endregion



  openModal(template: TemplateRef<any>): void {
    const dialogRef = this.dialog.open(template, {
      disableClose: true,
      width: "600px"
    });

  }

  isValidUrl(url: string): boolean {
    const urlPattern = /^(https?|http):\/\/[^\s\$.?#].[^\s]*$/i;
    return urlPattern.test(url);
  }

  async next(stepper: MatStepper) {
    if (stepper.selectedIndex == 0) {
      const authUrl = this.AuthApiGroup.get('authApiUrl')?.value;
      this.makeAuthApiCall();
      stepper.next();
    } else if (stepper.selectedIndex == 1) {

      this.AddAuthApi()
      this.closeTemplate();
    }
  }

  closeTemplate(): void {
    this.dialog.closeAll();
  }

  AddAuthApi() {

    const auth = this.AuthApiGroup.get('auth')?.value;
    const authTokenField = this.AuthApiGroup.get('apiKey')?.value;

    let authobj: any = {
      authApiUrl: this.AuthApiGroup.get('authApiUrl')?.value,
      auth: auth
    }
    if (this.authApiuserCreds.valid) {
      authobj['userName'] = this.authApiuserCreds.get('authUsername')?.value;
      authobj['password'] = this.authApiuserCreds.get('authPassword')?.value;
      authobj['authTokenField'] = authTokenField;
    } else if (this.authApiEmailCreds.valid) {
      authobj['email'] = this.authApiEmailCreds.get('authEmail')?.value;
      authobj['password'] = this.authApiEmailCreds.get('authPassword')?.value;
      authobj['authTokenField'] = authTokenField;
    } else if (auth === 'key') {
    }

    this.authApiData = { ...authobj };
  }

  openAuthDialog(template: TemplateRef<any>, type: string, index?: number): void {
    if (type == 'Add') {
      this.showEditOption = false;
      this.openModal(template);
    } else if (type == 'Edit') {
      this.showEditOption = true;
      if (index != undefined) {
        let authobj: any = { ...this.authApiData };
        this.AuthApiGroup.patchValue({
          authApiUrl: authobj.authApiUrl,
          auth: authobj.auth,
          authKey: authobj.authKey ? authobj.authkey : '',
        })
        if (authobj.auth === 'user') {
          this.authApiuserCreds.patchValue({
            authUsername: authobj.userName,
            authPassword: authobj.password,
          })
        } else if (authobj.auth === 'email') {
          this.authApiEmailCreds.patchValue({
            authEmail: authobj.email,
            authPassword: authobj.password,
          })
        } else if (authobj.auth === 'key') {

        }
      }
      this.openModal(template);
    }
  }

  addField(): FormGroup {
    return this._formBuilder.group({
      widgetId: '',
    });
  }

  patchField(data: any): FormGroup {
    return this._formBuilder.group({
      widgetId: data,
    });
  }
  getFilteredOptions(index: number, type: any): any[] {
    const selectedOptions = type === 'lhs'
      ? this.lhsItems.controls.filter((control, i) => i !== index).map((control: any) => control.get('widgetId').value)
      : this.rhsItems.controls.filter((control, i) => i !== index).map((control: any) => control.get('widgetId').value);
    const otherSideOptions = type === 'lhs'
      ? this.rhsItems.controls.map((control: any) => control.get('widgetId').value)
      : this.lhsItems.controls.map((control: any) => control.get('widgetId').value);
    return this.listOfWidgetsOfEntity.filter((option: any) =>
      !selectedOptions.includes(option.widgetId) && !otherSideOptions.includes(option.widgetId)
    );
  }
  addLhsFieldsInCard() {
    this.isLhsclicked = true;
    this.lhsItems.push(this.addField());
  }

  removeLhsFieldsInCard(index: number) {
    this.lhsItems.removeAt(index)
  }

  addRhsFieldsInCard() {
    this.isRhsclicked = true;
    this.rhsItems.push(this.addField())
  }

  removeRhsFieldsInCard(index: number) {
    this.rhsItems.removeAt(index);
  }

  getEntitiesOrAttributes(payload: any): any {
    return new Observable((observer) => {
      const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['GET_ENTITIES_OR_ATTRIBUTES']);
      apiConfig.postData = payload
      return this.httpService.placeAPICall(apiConfig).subscribe({
        next: (data: any) => {
          observer.next(data?.data);
          observer.complete();
        },
        error: (error: any) => {
          observer.error(error);
          observer.complete();
        }
      });
    })
  }

  formatListOfwidgetsOfEntity(list: any) {
    list?.forEach((item: any) => {
      item.show = false;
    })
    return list;
  }
  async onEntitySelected() {
    this.lhsItems.clear();
    this.rhsItems.clear();
    const payload = {
      application_id: this.applicationId,
      entity_id: this.dataListGroup.value.entity,
      project_id: null,
      parent_entity_id: null
    }
    const listOfPageWidgetsOfEntity = await this.getEntitiesOrAttributes(payload).toPromise();
    this.pageIdsOfAssociatedEntity = listOfPageWidgetsOfEntity?.page_ids ?? [];
    this.listOfWidgetsOfEntity = this.retriveWidgetsListFromEntiy(listOfPageWidgetsOfEntity?.page_widget_details)
    this.listOfWidgetsOfEntity = this.formatListOfwidgetsOfEntity(this.listOfWidgetsOfEntity);
  }

  updateDataListWidget(widgetData: any) {
    const selectedWidgetMetaDataWidgetConfig = this.selectedWidgetMetaData.widgetConfig;
    selectedWidgetMetaDataWidgetConfig.dataListWidgetConfig = {
      type: widgetData.type,
      entityId: widgetData.entity,
      lhsItems: this.formatItemsArray(widgetData.lhsItems),
      rhsItems: this.formatItemsArray(widgetData.rhsItems),
      listOfWidgetsOfEntity: this.listOfWidgetsOfEntity
    }
    this.selectedWidgetMetaData.widgetConfig = selectedWidgetMetaDataWidgetConfig;
    if (this.page.pageId) {
      this.sharedService.updateWidgetData(this.page.pageId, this.sectionIndex, this.widgetId, this.selectedWidgetMetaData);
    }
  }

  formatItemsArray(widgetsArray: any) {
    widgetsArray?.forEach((item: any) => {
      item.widgetLabel = this.listOfWidgetsOfEntity?.filter((x: any) => x.widgetId == item.widgetId)?.[0]?.widgetLabel;
    })
    return widgetsArray;
  }

  createOrUpdateDataListViewPage() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['CREATE_OR_UPDATE_DATALIST_VIEWPAGE']);
    apiConfig.postData = {
      applicationId: this.applicationId,
      entityId: this.dataListGroup.value.entity,
      entityName: this.listOfEntitiesOfApplication?.filter((x: any) => x.entity_id == this.dataListGroup.value.entity)?.[0]?.entity_name,
      widgetId: this.selectedWidgetMetaData.widgetId,
      listOfWidgetsOfEntity: this.listOfWidgetsOfEntity,
      pageIdsOfEntity: this.pageIdsOfAssociatedEntity
    }
    return this.httpService.placeAPICall(apiConfig).subscribe({
      next: (data: any) => {
      },
      error: (error: any) => {
        this.toasterService.error('Failed to create Data list view page');
      }
    });
  }


  async fetchPreviewScreen() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['FETCH_PREVIEW']);

    apiConfig.postData = {
      applicationId: this.applicationId,
      pageId: this.page.pageId,
      widgetId: this.selectedWidgetMetaData.widgetId
    }

    const data = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          this.selectedWidgetMetaData.widgetConfig['previewPageId'] = response?.previewPageId;
          resolve(response);
        },
        complete: () => {
          // this.sharedService.getAllPagesRefreshActionTrigger();
        },
        error: (err: any) => {
          resolve(err);
        }
      })
    })
  }

  async deletePreviewScreen() {
    const apiConfig: HTTPAPIConfig = this.dataService.deepClone(APIConfigMapping['DELETE_PREVIEW']);
    apiConfig.postData = {
      applicationId: this.applicationId,
      previewPageId: this.selectedWidgetMetaData.widgetConfig?.previewPageId ? this.selectedWidgetMetaData.widgetConfig?.previewPageId : "",
      widgetId: this.selectedWidgetMetaData.widgetId
    }
    const data = await new Promise((resolve: any, reject) => {
      this.httpService.placeAPICall(apiConfig).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        complete: () => {
          delete this.selectedWidgetMetaData.widgetConfig['previewPageId'];
        },
        error: (err: any) => {
          resolve(err);
        }
      })

    })
  }

  retriveWidgetsListFromEntiy(pageWidgetDetails: any) {
    const allWidgetDetails: { widgetId: string; widgetLabel: string }[] = [];
    pageWidgetDetails?.forEach((page: any) => {
      allWidgetDetails.push(...page.widget_details);
    });
    return allWidgetDetails;
  }
  isEntityClicked() {
    this.isEntityTouched = true;
  }

  editValidations(validation: any) {
    this.editMode = true
    this.showValidationForm = true;
    this.inputFieldValidationData = [];
    this.selectedValidationIndex = this.selectedWidgetMetaData.widgetConfig.validations.indexOf(validation);
    this.inputFieldValidationData.includes(validation.validation_type) ? "" : this.inputFieldValidationData.push(validation.validation_type);
    if (validation.validation_type == 'Required') {
      this.validationForm.patchValue({
        selectedValidationType: validation.validation_type,
        requiredMessage: validation.error_message,
        validationValue: validation.validation_value
      })
    }
    else {
      this.validationForm.patchValue({
        selectedValidationType: validation.validation_type,
        validationValue: validation.validation_value
      })
    }
  }

  editDatasourceValues(index: any) {
    this.editMode = true
    this.selectedDataSourceIndex = index
    const existingValue = this.dataSourceValues[index];
    this.editedDataSourceValue = existingValue
    this.valuesForm.patchValue({
      label: existingValue,
    });

  }

  updateEditedDataSource() {
    const newValue = this.valuesForm.get('label')?.value;
    const index = this.dataSourceValues.indexOf(this.editedDataSourceValue);
    if (this.dataSourceValues.includes(newValue)) {
      this.editMode = false;
      this.valuesForm.get('label')?.reset();
      this.lableExisted = true;
    }
    else if (index !== -1) {
      this.dataSourceValues[index] = newValue;
      this.valuesForm.get('label')?.reset();
      this.editMode = false;
      this.lableExisted = false;
    }
  }

  //#region widget actions

  addAction(action: string) {
    if (action == this.widgetActionTypes.conditionalNavigation) {
      this.conditionalActionGroup.reset();
      this.NavigationConditionals = [];
    }
    this.buttonActions = this.buttonActions.filter((item: any) => item !== action)

    this.selectedActions.push(action);
  }
  //#endregion

  updateDiplayWidgetValues() {
    if(this.selectedWidgetMetaData.widgetType === 'map')
    this.selectedWidgetMetaData.widgetConfig.mapConfig = this.mapFormGroup.value;
    else
    this.selectedWidgetMetaData.widgetConfig.chartConfig = this.chartDetailsFormGroup.value;
    this.highChartService.SetUpdatedDisplayWidgetDataConfig(true);
    const widgetPostData = {
      applicationId: this.applicationId,
      widgetConfig: this.selectedWidgetMetaData.widgetConfig,
      widgetLabel: this.selectedWidgetMetaData.widgetLabel,
      userId: JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
      widgetId: this.widgetId,
    }
    this.sharedService.updateWidget(widgetPostData, this.selectedWidgetMetaData.widgetId).subscribe((data:any) => {
    })

  }

  updateTableWidgetValues() {
    this.selectedWidgetMetaData.widgetConfig.tableConfig = this.tableGroup.value;
    const widgetPostData = {
      applicationId: this.applicationId,
      widgetConfig: this.selectedWidgetMetaData.widgetConfig,
      widgetLabel: this.selectedWidgetMetaData.widgetLabel,
      userId: JSON.parse(localStorage.getItem('userInfo') as any)?.['userId'],
      widgetId: this.widgetId,
    }
    this.sharedService.updateWidget(widgetPostData, this.selectedWidgetMetaData.widgetId).subscribe((data:any) => {
    })

  }

  async getApiOrEntityDefinitionBasedOnForm(type: string, selectedId: string) {
    try {
      if (type === 'api') {
        let api = this.userApis.find((item:any) => item.apiId == selectedId);
        this.makeChartDataSourceApiRequest(api.apiURL, api.method, api.requestBody, api.headers,api.apiId);
        // this.makeChartDataSourceApiRequest(formValue.apiUrl, formValue.httpMethod, postData, headers);
      }
      else if (type === 'entity') {
        const entityId = selectedId;
        const entitySubmissionData = await this.wformService.getEntitySubmissionData(entityId).toPromise();
        this.handleResponse(entitySubmissionData);
        this.addDataSource(true,entityId,'entity')
      }
    }
    catch (error: any) {
      this.handleApiError(error);
    }
  }

  makeChartDataSourceApiRequest(apiUrl: string, method: string, requestData: any, headers: HttpHeaders,apiId?:string): void {

    const requestOptions = { headers };
    let requestObservable;

    switch (method) {
      case 'GET':
        requestObservable = this.http.get(apiUrl, requestOptions);
        break;
      case 'POST':
        requestObservable = this.http.post(apiUrl, requestData, requestOptions);
        break;
      default:
        throw new Error('Invalid HTTP method');
    }

    const chartDataSOurceApiSubscription: any = requestObservable.subscribe({
      next: (response: any) => {this.handleResponse(response),this.addDataSource(true,apiId,'api')},
      error: (error) => this.handleApiError(error)
    }
    );
    this.subscrptions.push(chartDataSOurceApiSubscription);
  }

  handleResponse(response: any) {
    let sourceData: any[] = []
    let widgetConfig =   this.selectedWidgetMetaData.widgetConfig
    if (Array.isArray(response) && response.length > 0) {
      this.apikeys = Object.keys(response[0]);
      sourceData = response;
    }
    else if (typeof (response) === 'object' && Array.isArray(response.data) && response.data.length > 0) {
      this.apikeys = Object.keys(response.data[0])
      sourceData = response.data;
    }
    else {
      this.toasterService.warning('The Api Does not return list of values');
    }
    if(this.selectedWidgetMetaData.widgetType==='map'){
      widgetConfig.mapDataSourceData = sourceData;
      sourceData.forEach((obj:any)=>{
        Object.keys(obj).forEach((key:any)=>{
          if(!this.mapContentData.includes(key)){
            this.mapContentData.push(key);
          }
        })
      })
    }else if(this.selectedWidgetMetaData.widgetType===this.widgetTypes.table){
      widgetConfig.tableData = sourceData;
    }else{
    widgetConfig.chartDataSourceData = sourceData;
    }
  }
  addOrEditDatSourceConfig(type: string, template: TemplateRef<any>): void {
    const dialogRef = this.dialog.open(template, {
      disableClose: true,
      width: "600px"
    })
  }

  ngOnDestroy() {
   this.unsubscribeAllSubscriptions();
  }

  unsubscribeAllSubscriptions() {
    for (const subscription of this.subscrptions) {
      subscription.unsubscribe();
    }
  }
  /**
    checks whether the given validation matches the selected validation
   */
    checkValidationMatched(value:string){
      return this.validationForm.get('selectedValidationType')?.value === value;
    }

    copyToClipboard(widgetId:string){
      this.clipboard.copy(widgetId);
    }
}
